import { useEffect, useState, useRef, useLayoutEffect } from 'react'
import { 
    GetAllSelfies as BLGetAllSelfies, 
    SelectSelfie as BLSelectSelfie, 
    DeselectSelfie as BLDeselectSelfie, 
    DeleteSelfie as BLDeleteSelfie, 
    ResetDinamyc as BLResetDinamyc, 
    FormatDateToMexico, 
    GetSelfiesPage as BLGetSelfiesPage, 
    SendSelfiesFanIAToScreen as BLSendSelfiesFanIAToScreen, 
    DeselectSelfieFanIA as BLDeselectSelfieFanIA, 
    UpdateOverlayPositionAndScale as BLUpdateOverlayPositionAndScale,
    GetOverlaySettings as BLGetOverlaySettings,
    SaveOverlaySettings as BLSaveOverlaySettings,
    SendQRToOverlay as BLSendQRToOverlay,
    SendMessagesQRToOverlay as BLSendMessagesQRToOverlay
} from './../../../utilities/BL/SelfieFan'
import { Loading } from '../../Commons/Loading'
import { SecondaryBase } from '../Commons/SecondaryBase'
import { ResetCurrentDynamic as BLResetCurrentDynamic } from './../../../utilities/BL/Zones'
import { BLGetMessages, BLToggleVisibility } from './../../../utilities/BL/FanMessages'

import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'
import { Confirm } from './../../Commons/Modals/Confirm'
import { FormatDateTimeToDownloadImages as BLFormatDateTimeToDownloadImages } from './../../../utilities/BL/Commons/DatesAndTimes'

import { useSelfiePlayer } from './SelfieFanPlayer/useSelfieFanPlayer'

const PAGE_SIZE = 30; 

const types = {
  SELECT: 1, DESELECT: 2, DELETE: 3, RESET: 4,
  IA_SHOW1: "IA_SHOW1", IA_SHOW_BOTH: "IA_SHOW_BOTH", IA_CLEAR: "IA_CLEAR",
  PLAYER_CLEAR: "PLAYER_CLEAR",
  CONFIRM_START_LIVE: "CONFIRM_START_LIVE",
  CONFIRM_STOP_LIVE: "CONFIRM_STOP_LIVE",
  DELETE_FROM_QUEUE: "DELETE_FROM_QUEUE",
  CLEAR_QUEUE: "CLEAR_QUEUE"
};

const initialPagedState = {
  items: [],
  nextCursor: null,
  loading: false,
  exhausted: false,
};

const SelfieFanPlayer = ({ getOutOfTheDynamic }) => {
  const { showMessage } = useFloatMessage();

  const playerActions = {
    sendToScreenFC: async (item) => {
      const resp = await BLSelectSelfie(item);
      if (!resp.success) throw new Error(resp.message);
      return resp;
    },
    sendToScreenIA: async (payload) => {
      const resp = await BLSendSelfiesFanIAToScreen(payload);
      if (!resp.success) throw new Error(resp.message);
      return resp;
    },
    clearScreen: async () => {
      await BLDeselectSelfie();
      await BLDeselectSelfieFanIA();
    }
  };

  const handleItemShown = (id) => {
      setFan(prev => ({...prev, items: prev.items.map(x => x.id === id ? { ...x, wasShown: true } : x)}));
      setStaff(prev => ({...prev, items: prev.items.map(x => x.id === id ? { ...x, wasShown: true } : x)}));
      setIA(prev => ({...prev, items: prev.items.map(x => x.id === id ? { ...x, wasShown: true } : x)}));
  };

  const player = useSelfiePlayer(playerActions, showMessage, handleItemShown);

  const [isLoading, setIsLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ FC: 'DESC', IA: 'DESC', ST: 'DESC' });

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [selfie, setSelfie] = useState(null); 

  const [fan, setFan]     = useState({ ...initialPagedState }); 
  const [staff, setStaff] = useState({ ...initialPagedState }); 
  const [ia, setIA]       = useState({ ...initialPagedState }); 

  const [selectedForScreen, setSelectedForScreen] = useState({ 1: null, 2: null });
  const [animationByScreen, setAnimationByScreen] = useState({ 1: 0, 2: 0 });
  const [activeShowAction, setActiveShowAction]   = useState(null); 
  const [isClearingIA, setIsClearingIA]           = useState(false);

  const fanContainerRef   = useRef(null);
  const staffContainerRef = useRef(null);
  const iaContainerRef    = useRef(null);
  
  const fanCollapsibleRef   = useRef(null);
  const staffCollapsibleRef = useRef(null);
  const iaCollapsibleRef    = useRef(null);
  
  const [isFanCollapsed, setIsFanCollapsed]     = useState(false);
  const [isStaffCollapsed, setIsStaffCollapsed] = useState(false);
  const [isIACollapsed, setIsIACollapsed]       = useState(false);

  const [overlayX, setOverlayX] = useState(0);
  const [overlayY, setOverlayY] = useState(0);
  const [overlayScale, setOverlayScale] = useState(1.0);
  const [savedConfig, setSavedConfig] = useState({ x: 0, y: 0, scale: 1.0 });
  const [lastSavedDate, setLastSavedDate] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isOverlayLoaded, setIsOverlayLoaded] = useState(false); 
  const isFirstRenderForOverlay = useRef(true);
  const [isOverlaySyncing, setIsOverlaySyncing] = useState(false);
  const [isDraggingTrackpad, setIsDraggingTrackpad] = useState(false);
  const dragAnchorReference = useRef({ x: 0, y: 0, startOverlayX: 0, startOverlayY: 0 });

  // Estados para control de "Mensajes a la afición" (FanMessages)
  const [fanMessagesList, setFanMessagesList] = useState([]);
  const [selectedFanMessageId, setSelectedFanMessageId] = useState('');
  const [loadingFanMessage, setLoadingFanMessage] = useState(false);

  useEffect(() => {
      if (!isOverlayLoaded) return;
      if (isFirstRenderForOverlay.current) {
          isFirstRenderForOverlay.current = false;
          return;
      }
      const isChanged = overlayX !== savedConfig.x || overlayY !== savedConfig.y || overlayScale !== savedConfig.scale;
      setHasUnsavedChanges(isChanged);
      if (!isChanged && !isDraggingTrackpad) return;

      setIsOverlaySyncing(true);
      const debounceTimer = setTimeout(async () => {
          try {
              await BLUpdateOverlayPositionAndScale(overlayX, overlayY, overlayScale);
              setIsOverlaySyncing(false);
          } catch (error) {
              console.error("Error sincronizando overlay en vivo:", error);
              setIsOverlaySyncing(false);
          }
      }, 150);
      return () => clearTimeout(debounceTimer);
  }, [overlayX, overlayY, overlayScale, isOverlayLoaded]);

  const handleApplyOverlayToScreen = async () => {
      setIsOverlaySyncing(true);
      try {
          await BLUpdateOverlayPositionAndScale(overlayX, overlayY, overlayScale);
          showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Posición enviada a la pantalla (OBS)." });
      } catch (error) {
          showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al enviar a la pantalla." });
      } finally {
          setIsOverlaySyncing(false);
      }
  };

  const handleSaveOverlayConfig = async () => {
      try {
          const resp = await BLSaveOverlaySettings(overlayX, overlayY, overlayScale);
          if (resp.success) {
              setSavedConfig({ x: overlayX, y: overlayY, scale: overlayScale });
              setHasUnsavedChanges(false);
              setLastSavedDate(new Date());
              showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Configuración guardada en Base de Datos." });
          } else {
              throw new Error(resp.message);
          }
      } catch (error) {
          showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al guardar en BD." });
      }
  };

  const handleShowQROverlay = async () => {
      try {
          const resp = await BLSendQRToOverlay();
          if (resp.success) {
              showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Código QR de selfiefan enviado a la pantalla." });
          } else {
              throw new Error(resp.message);
          }
      } catch (error) {
          showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al enviar QR." });
      }
  };

  const handleShowMessagesQROverlay = async () => {
      try {
          const resp = await BLSendMessagesQRToOverlay();
          if (resp.success) {
              showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Código QR de mensajes enviado a la pantalla." });
          } else {
              throw new Error(resp.message);
          }
      } catch (error) {
          showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al enviar QR." });
      }
  };

  const handleTrackpadPointerDown = (event) => {
      setIsDraggingTrackpad(true);
      dragAnchorReference.current = {
          x: event.clientX || (event.touches && event.touches[0].clientX),
          y: event.clientY || (event.touches && event.touches[0].clientY),
          startOverlayX: overlayX,
          startOverlayY: overlayY
      };
      if (event.target.setPointerCapture) event.target.setPointerCapture(event.pointerId);
  };

  const handleTrackpadPointerMove = (event) => {
      if (!isDraggingTrackpad) return;
      const currentPointerX = event.clientX || (event.touches && event.touches[0].clientX);
      const currentPointerY = event.clientY || (event.touches && event.touches[0].clientY);
      const deltaX = currentPointerX - dragAnchorReference.current.x;
      const deltaY = currentPointerY - dragAnchorReference.current.y;
      const dragSensitivity = 3; 

      let calculatedNewX = Math.round(dragAnchorReference.current.startOverlayX - (deltaX * dragSensitivity));
      let calculatedNewY = Math.round(dragAnchorReference.current.startOverlayY - (deltaY * dragSensitivity));

      const MAX_X = 1700;
      const MAX_Y = 700;  

      calculatedNewX = Math.max(0, Math.min(MAX_X, calculatedNewX));
      calculatedNewY = Math.max(0, Math.min(MAX_Y, calculatedNewY));

      setOverlayX(calculatedNewX);
      setOverlayY(calculatedNewY);
  };

  const handleTrackpadPointerUp = () => { setIsDraggingTrackpad(false); };

  const btnClass = (base, isActive) => `${base} ${isActive ? "Btn__Adsl--Success" : ""}`;

  const getSortedItems = (items, type) => {
    if (!items || items.length === 0) return [];
    const order = sortConfig[type] || 'DESC'; 
    return [...items].sort((a, b) => {
        const idxA = (typeof a.index === 'number') ? a.index : 0;
        const idxB = (typeof b.index === 'number') ? b.index : 0;
        return order === 'ASC' ? idxA - idxB : idxB - idxA; 
    });
  };

  const setOrderFor = (type, order) => { setSortConfig(prev => ({ ...prev, [type]: order })); };

  const useCollapsibleParent = (parentRef, contentRef, isCollapsed) => {
    useLayoutEffect(() => {
      const parent = parentRef.current;
      const content = contentRef.current;
      if (!parent || !content) return;
      parent.style.overflow = "hidden";
      parent.style.transition = "max-height .25s ease";
      const setMax = () => { parent.style.maxHeight = isCollapsed ? "0px" : `${content.scrollHeight}px`; };
      setMax();
      const ro = new ResizeObserver(() => { if (!isCollapsed) parent.style.maxHeight = `${content.scrollHeight}px`; });
      ro.observe(content);
      return () => ro.disconnect();
    }, [parentRef, contentRef, isCollapsed]);
  };
  useCollapsibleParent(fanCollapsibleRef, fanContainerRef, isFanCollapsed);
  useCollapsibleParent(staffCollapsibleRef, staffContainerRef, isStaffCollapsed);
  useCollapsibleParent(iaCollapsibleRef,  iaContainerRef,  isIACollapsed);

  const preserveScroll = (containerRef, updateFn) => {
    const el = containerRef.current;
    if (!el) return updateFn();
    const prevTop = el.scrollTop;
    const prevHeight = el.scrollHeight;
    updateFn();
    requestAnimationFrame(() => {
      const newHeight = el.scrollHeight;
      el.scrollTop = prevTop + (newHeight - prevHeight);
    });
  };

  const mergePage = (prev, page) => {
    const map = new Map(prev.items.map((x) => [x.id, x]));
    for (const it of page.items) map.set(it.id, { ...(map.get(it.id) || {}), ...it });
    return { items: Array.from(map.values()), nextCursor: page.nextCursor ?? null, loading: false, exhausted: !page.nextCursor };
  };

  const markLoading = (prev) => ({ ...prev, loading: true });

  const loadFirstPage = async (source) => {
    let setState;
    if (source === "selfie_staff") setState = setStaff;
    else if (source === "selfie_ia") setState = setIA;
    else setState = setFan;

    setState({ ...initialPagedState, loading: true });
    try {
      const resp = await BLGetSelfiesPage({ source, limit: PAGE_SIZE, cursor: null });
      if (resp.success) setState(mergePage(initialPagedState, { items: resp.data.items, nextCursor: resp.data.nextCursor }));
    } catch (err) { setState({ ...initialPagedState, loading: false }); showMessage({ type: MESSAGE_TYPE.BAD, text: err.message }); }
  };

  const loadMore = async (source) => {
    let state, setState, container;
    if (source === "selfie_staff") { state = staff; setState = setStaff; container = staffContainerRef; }
    else if (source === "selfie_ia") { state = ia; setState = setIA; container = iaContainerRef; }
    else { state = fan; setState = setFan; container = fanContainerRef; }

    if (state.loading) return; 
    setState(markLoading);
    try {
      if (state.nextCursor) {
        const resp = await BLGetSelfiesPage({ source, limit: PAGE_SIZE, cursor: state.nextCursor });
        if (!resp.success) throw new Error(resp.message);
        preserveScroll(container, () => setState((prev) => mergePage(prev, { items: resp.data.items, nextCursor: resp.data.nextCursor })));
      } else {
        const resp = await BLGetSelfiesPage({ source, limit: PAGE_SIZE, cursor: null });
        if (!resp.success) throw new Error(resp.message);
        const existingIds = new Set(state.items.map((x) => x.id));
        const latest = state.items.length ? new Date(Math.max(...state.items.map((x) => new Date(x.createdAtUtc).getTime()))) : null;
        const incoming = resp.data.items;
        const onlyNew = incoming.filter((x) => !existingIds.has(x.id) && (!latest || new Date(x.createdAtUtc) > latest));
        if (!onlyNew.length) { setState((prev) => ({ ...prev, loading: false })); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "No hay más por ahora." }); return; }
        preserveScroll(container, () => setState(prev => ({ ...prev, items: [...prev.items, ...onlyNew], loading: false })));
      }
    } catch (err) { setState((prev) => ({ ...prev, loading: false })); showMessage({ type: MESSAGE_TYPE.BAD, text: err.message || "Error al cargar más." }); }
  };

  const loadOverlayData = async () => {
      try {
          const resp = await BLGetOverlaySettings();
          if (resp && resp.success && resp.data) {
              setOverlayX(resp.data.x);
              setOverlayY(resp.data.y);
              setOverlayScale(resp.data.scale);
              setSavedConfig({ x: resp.data.x, y: resp.data.y, scale: resp.data.scale });
              if(resp.data.lastSavedAt) setLastSavedDate(new Date(resp.data.lastSavedAt));
          }
      } catch (error) {
          console.error("Error cargando config de overlay", error);
      } finally {
          setIsOverlayLoaded(true);
      }
  };

  const loadFanMessagesList = async () => {
      try {
          const resp = await BLGetMessages();
          if (resp && resp.success) {
              setFanMessagesList(resp.data || []);
          }
      } catch (error) {
          console.error("Error al cargar mensajes a la afición en SelfieFan:", error);
      }
  };

  const handleShowFanMessage = async () => {
      if (!selectedFanMessageId || Number(selectedFanMessageId) <= 0) {
          showMessage({ type: MESSAGE_TYPE.WARNING, text: 'Selecciona el mensaje para la afición antes de continuar.' });
          return;
      }

      setLoadingFanMessage(true);
      showMessage({ type: MESSAGE_TYPE.INFO, text: 'Enviando mensaje a la afición a la pantalla...' });
      try {
          const resp = await BLToggleVisibility(Number(selectedFanMessageId), true, 'selfiefan');
          if (resp && resp.success) {
              showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Mensaje a la afición proyectado en pantalla.' });
          } else {
              showMessage({ type: MESSAGE_TYPE.BAD, text: resp?.message || 'Error al mostrar mensaje a la afición.' });
          }
      } catch (error) {
          showMessage({ type: MESSAGE_TYPE.BAD, text: error?.message || 'Error al comunicar con el servidor.' });
      } finally {
          setLoadingFanMessage(false);
      }
  };

  const handleHideFanMessage = async () => {
      if (!selectedFanMessageId || Number(selectedFanMessageId) <= 0) {
          showMessage({ type: MESSAGE_TYPE.WARNING, text: 'Selecciona el mensaje para la afición antes de continuar.' });
          return;
      }

      setLoadingFanMessage(true);
      showMessage({ type: MESSAGE_TYPE.INFO, text: 'Ocultando mensaje a la afición de la pantalla...' });
      try {
          const resp = await BLToggleVisibility(Number(selectedFanMessageId), false, 'selfiefan');
          if (resp && resp.success) {
              showMessage({ type: MESSAGE_TYPE.SUCCESS, text: 'Mensaje a la afición quitado de la pantalla.' });
          } else {
              showMessage({ type: MESSAGE_TYPE.BAD, text: resp?.message || 'Error al ocultar mensaje a la afición.' });
          }
      } catch (error) {
          showMessage({ type: MESSAGE_TYPE.BAD, text: error?.message || 'Error al comunicar con el servidor.' });
      } finally {
          setLoadingFanMessage(false);
      }
  };

  const reloadNow = async () => { 
      await Promise.all([
          loadFirstPage("selfie_fan"), 
          loadFirstPage("selfie_staff"), 
          loadFirstPage("selfie_ia"), 
          loadOverlayData(),
          loadFanMessagesList()
      ]); 
      showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Listado actualizado." }); 
  };
  
  useEffect(() => { (async () => { await reloadNow(); setIsLoading(false); })(); }, []);
  const ReturnToDashboard = async () => { try { await BLResetCurrentDynamic(); } finally { getOutOfTheDynamic(); } };

  const apiRotate = async (id) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}SelfieFan/${id}/rotate`;
      const res = await fetch(url, { method: 'POST' });
      if (!res.ok) throw new Error("Error al rotar");
      
      const timestamp = new Date().getTime(); 
      const updateImageCache = (list) => list.map(item => {
          if (item.id !== id) return item;
          const cleanUrl = item.thumbUrl.split('?')[0]; 
          const newUrl = `${cleanUrl}?t=${timestamp}`;
          return { ...item, thumbUrl: newUrl }; 
      });

      setFan(prev => ({ ...prev, items: updateImageCache(prev.items) }));
      setStaff(prev => ({ ...prev, items: updateImageCache(prev.items) }));
      setIA(prev => ({ ...prev, items: updateImageCache(prev.items) }));
      
      const targetItem = fan.items.find(x => x.id === id) || staff.items.find(x => x.id === id) || ia.items.find(x => x.id === id);
      if(targetItem) {
          const cleanUrl = targetItem.thumbUrl.split('?')[0];
          const newUrl = `${cleanUrl}?t=${timestamp}`;
          player.refreshItemInQueue(id, newUrl, 0); 
      }
      showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Imagen rotada." });
    } catch { showMessage({ type: MESSAGE_TYPE.BAD, text: "No se pudo rotar." }); }
  };

  const apiToggleHide = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const headers = {};
      if (token) headers['Authorization'] = `Bearer ${token}`;
      if (user?.username) headers['X-Moderator-Id'] = user.username;

      const url = `${process.env.REACT_APP_API_URL}SelfieFan/${id}/toggle-hide`;
      const res = await fetch(url, { method: 'POST', headers });
      if (!res.ok) throw new Error("Error");
      const updateVisibility = (list) => list.map(item => item.id === id ? { ...item, isHidden: !item.isHidden } : item);
      setFan(prev => ({ ...prev, items: updateVisibility(prev.items) }));
      setStaff(prev => ({ ...prev, items: updateVisibility(prev.items) }));
      setIA(prev => ({ ...prev, items: updateVisibility(prev.items) }));
      showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Visibilidad actualizada." });
    } catch { showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al ocultar." }); }
  };

  const apiDownloadAll = () => {
    const url = `${process.env.REACT_APP_API_URL}SelfieFan/download-all`;
    window.open(url, '_blank');
    showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Generando ZIP..." });
  };

  const handleLiveToggleRequest = () => { setModalType(player.isLive ? types.CONFIRM_STOP_LIVE : types.CONFIRM_START_LIVE); setShowConfirmModal(true); };
  const confirmLiveAction = () => { player.toggleLive(!player.isLive); setShowConfirmModal(false); };
  const handleClearScreenRequest = () => { setModalType(types.PLAYER_CLEAR); setShowConfirmModal(true); };
  const confirmClearScreen = async () => { await player.emergencyStop(); setShowConfirmModal(false); };
  const handleDeleteFromQueueRequest = (index) => { setModalData({ index }); setModalType(types.DELETE_FROM_QUEUE); setShowConfirmModal(true); };
  const confirmDeleteFromQueue = () => { if (modalData && typeof modalData.index === 'number') { player.removeFromQueue(player.activeTab, modalData.index); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Eliminado." }); } setShowConfirmModal(false); };
  const confirmClearQueue = () => { player.clearQueue(player.activeTab); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Fila vaciada." }); setShowConfirmModal(false); };
  
  const handleAddToQueueSingle = (item) => { 
      if (item.isHidden) return; 
      const targetQueue = item.source === 'selfie_staff' ? 'ST' : 'FC';
      player.addToQueue(targetQueue, item); 
      showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Agregado." }); 
  };

  const handleAddSetToQueueIA = () => { if (!selectedForScreen[1] || !selectedForScreen[2]) { showMessage({ type: MESSAGE_TYPE.BAD, text: "Selecciona 2 imágenes." }); return; } const item1 = ia.items.find(x => x.id === selectedForScreen[1]); const item2 = ia.items.find(x => x.id === selectedForScreen[2]); if (item1?.isHidden || item2?.isHidden) { showMessage({ type: MESSAGE_TYPE.BAD, text: "Imagen oculta." }); return; } const newSet = { id: `SET-${Date.now()}`, img1_id: selectedForScreen[1], img2_id: selectedForScreen[2], anim1: animationByScreen[1], anim2: animationByScreen[2], img1_thumb: item1?.thumbUrl, img2_thumb: item2?.thumbUrl }; player.addToQueue('IA', newSet); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Set agregado." }); setSelectedForScreen({ 1: null, 2: null }); setAnimationByScreen({ 1: 0, 2: 0 }); };
  const ShowConfirmModalLegacy = (data, type) => { setSelfie(data); setModalType(type); setShowConfirmModal(true); };
  
  const handleDirectDownload = async (item, index) => { 
    try { 
        if (!item?.contentUrl) return; 
        const response = await fetch(`${process.env.REACT_APP_API_URL}SelfieFan/${item.id}/content`); 
        if (!response.ok) { showMessage({ type: MESSAGE_TYPE.BAD, text: "Error." }); return; } 
        const blob = await response.blob(); 
        const ext = item.contentType?.includes("png") ? "png" : "jpg"; 
        let sourceText = item.source === 'selfie_ia' ? '_IA' : (item.source === 'selfie_staff' ? '_STAFF' : ''); 
        const formattedDateTime = BLFormatDateTimeToDownloadImages(item.createdAtUtc) || 'date'; 
        const filename = `${index}${sourceText}_${formattedDateTime}.${ext}`; 
        const url = URL.createObjectURL(blob); 
        const a = document.createElement("a"); 
        a.href = url; 
        a.download = filename; 
        document.body.appendChild(a); 
        a.click(); 
        a.remove(); 
        URL.revokeObjectURL(url); 
    } catch { 
        showMessage({ type: MESSAGE_TYPE.BAD, text: "Error." }); 
    } 
  };
  
  const SelectSelfie = async () => { if (!selfie) return; if (selfie.isHidden) return; setSelectedForScreen({ 1: null, 2: null }); setAnimationByScreen({ 1: 0, 2: 0 }); const resp = await playerActions.sendToScreenFC(selfie); if(resp.success) { showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Mostrando." }); handleItemShown(selfie.id); } setShowConfirmModal(false); };
  const DeselectSelfie = async () => { const resp = await BLDeselectSelfie(); if(resp.success) { showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Quitado." }); setFan(prev => ({...prev, items: prev.items.map(x => ({...x, isSelected: false}))})); setStaff(prev => ({...prev, items: prev.items.map(x => ({...x, isSelected: false}))})); } setShowConfirmModal(false); };
  
  const DeleteSelfie = async () => { 
      if (!selfie) return; 
      const s = selfie; 
      if (s.source === "selfie_ia") { setIA(prev => ({ ...prev, items: prev.items.filter(x => x.id !== s.id) })); } 
      else if (s.source === "selfie_staff") { setStaff(prev => ({ ...prev, items: prev.items.filter(x => x.id !== s.id) })); } 
      else { setFan(prev => ({ ...prev, items: prev.items.filter(x => x.id !== s.id) })); } 
      
      const resp = await BLDeleteSelfie(s); 
      if(resp.success) showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Eliminado." }); 
      setShowConfirmModal(false); 
  };
  
  const ResetDinamyc = async () => { await BLResetCurrentDynamic(); setFan({ ...initialPagedState }); setStaff({ ...initialPagedState }); setIA({ ...initialPagedState }); player.clearQueue('FC'); player.clearQueue('ST'); player.clearQueue('IA'); await reloadNow(); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Reseteado." }); setShowConfirmModal(false); };
  const toggleCardForScreen = (screenNum, cardId) => { setSelectedForScreen(prev => { const other = screenNum === 1 ? 2 : 1; if (prev[screenNum] === cardId) { setAnimationByScreen(a => ({ ...a, [screenNum]: 0 })); return { ...prev, [screenNum]: null }; } if (prev[other] === cardId) { setAnimationByScreen(a => ({ ...a, [other]: 0 })); return { ...prev, [other]: null, [screenNum]: cardId }; } return { ...prev, [screenNum]: cardId }; }); };
  const setAnimationForScreen = (screenNum, animId) => { setAnimationByScreen(prev => ({ ...prev, [screenNum]: animId })); };
  const SendSelfiesFanIAToScreen = async (screens) => { const id1 = selectedForScreen[1]; const id2 = selectedForScreen[2]; const item1 = ia.items.find(x => x.id === id1); const item2 = ia.items.find(x => x.id === id2); if ((screens.includes(1) && item1?.isHidden) || (screens.includes(2) && item2?.isHidden)) { showMessage({ type: MESSAGE_TYPE.BAD, text: "Imagen oculta." }); return; } const dataToSend = []; if (screens.includes(1) && id1) dataToSend.push({ id: id1, animation: animationByScreen[1] || 0 }); if (screens.includes(2) && id2) dataToSend.push({ id: id2, animation: animationByScreen[2] || 0 }); if(!dataToSend.length) return; const resp = await playerActions.sendToScreenIA(dataToSend); if(resp.success) { showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Enviado." }); setActiveShowAction(screens.length === 1 ? "screen1" : "screen2"); const idsMostrados = [id1, id2].filter(x => x); idsMostrados.forEach(id => handleItemShown(id)); } setShowConfirmModal(false); };
  const ClearSelfiesFanIAFromScreen = async () => { await BLDeselectSelfieFanIA(); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Pantalla limpia." }); setShowConfirmModal(false); };

  if (isLoading) return <Loading />;

  const currentQItem = player.queues[player.activeTab][player.currentIndex[player.activeTab]];
  const isPauseIcon = player.playingTab === player.activeTab;

  return (
    <div className="SelfieFan">
      <SecondaryBase actionToExecute={ReturnToDashboard}>

        <div className="d-flex flex-wrap justify-content-center align-items-center mt-4 gap-3">
            <button type="button" className="Btn__Adsl--RedOutlineTransparent mb-0" onClick={reloadNow}><i className="bi bi-arrow-counterclockwise"></i> Actualizar listado</button>
            <button type="button" className="Btn__Adsl--RedOutlineTransparent mb-0" onClick={apiDownloadAll} title="Descargar todas las fotos en ZIP"><i className="bi bi-file-earmark-zip"></i> Descargar Todo</button>

            {/* Controles rápidos de Mensajes a la afición */}
            <div className='d-flex align-items-center gap-2 border border-secondary rounded px-3 py-2 bg-dark'>
                <i className='bi bi-chat-square-quote-fill text-warning fs-5' title="Mensajes a la afición"></i>
                <select 
                    className='form-select form-select-sm bg-dark text-white border-secondary' 
                    style={{ minWidth: '220px', maxWidth: '320px' }}
                    value={selectedFanMessageId} 
                    onChange={(e) => setSelectedFanMessageId(e.target.value)}
                    disabled={loadingFanMessage}
                >
                    <option value="">Selecciona el mensaje para la afición</option>
                    {fanMessagesList.map(item => (
                        <option key={item.id} value={item.id}>
                            #{item.id} - {item.title || item.mainText?.substring(0, 30)}
                        </option>
                    ))}
                </select>
                <button 
                    type="button" 
                    className='btn btn-sm btn-outline-success d-flex align-items-center gap-1' 
                    onClick={handleShowFanMessage}
                    disabled={loadingFanMessage}
                    title="Mostrar mensaje a la afición en overlay de Selfie Fan"
                >
                    <i className='bi bi-eye-fill'></i> Mostrar
                </button>
                <button 
                    type="button" 
                    className='btn btn-sm btn-outline-danger d-flex align-items-center gap-1' 
                    onClick={handleHideFanMessage}
                    disabled={loadingFanMessage}
                    title="Ocultar mensaje a la afición del overlay de Selfie Fan"
                >
                    <i className='bi bi-eye-slash-fill'></i> Ocultar
                </button>
            </div>
        </div>

        {/* ===================== SECCIÓN 1: REPRODUCTOR ===================== */}
        <div className='SelfieFan__Admin__Section'>
          <p className="SelfieFan__Admin__Title"><i className='bi bi-play-circle'></i> Reproductor de Selfie Fan</p>
          <button type="button" className="Btn__Adsl--RedOutlineTransparent d-block mx-auto mt-2" onClick={handleShowQROverlay}>
            <i className="bi bi-qr-code"></i> Proyectar QR de selfiefan en overlay
          </button>

          <button type="button" className="Btn__Adsl--RedOutlineTransparent d-block mx-auto mt-2" onClick={handleShowMessagesQROverlay}>
            <i className="bi bi-qr-code"></i> Proyectar QR de MENSAJES en overlay
          </button>

          <div className='SelfieFan__Admin__Player'>
            {/* --- DECK CONDICIONAL (FC o ST vs IA) --- */}
            {player.activeTab === 'FC' || player.activeTab === 'ST' ? (
                <div className='SelfieFan__Admin__Player__Deck'>
                   <button type='button' className='Btn__Adsl--RedOutlineTransparent mx-auto mt-1' onClick={handleClearScreenRequest}><i className='bi bi-x-circle'></i> Quitar de la pantalla</button>
                   <p className='SelfieFan__Admin__Player__Deck__LiveStatus'>Estatus: <i className={`bi bi-toggle-${player.isLive ? 'on text-success' : 'off'}`} onClick={handleLiveToggleRequest} title={player.isLive ? "En vivo" : "Detenido"}></i> {player.isLive ? "En vivo" : ""}</p>
                   <p className="SelfieFan__Admin__Player__Deck__Feedback">{player.projectionStatus}</p>
                   
                   <div className="SelfieFan__Admin__Player__Deck--FanCam__PreviewImage">
                     {currentQItem ? (<img src={currentQItem.thumbUrl} className='d-block w-100 h-100' style={{objectFit:'contain'}} alt='' key={currentQItem.thumbUrl} />) : <div className="text-white d-flex align-items-center justify-content-center h-100">No hay fotos en la fila</div>}
                   </div>
                   
                   <div className='SelfieFan__Admin__Player__Deck--FanCam__Intervals'>
                     <p className='mb-0 me-1'>Intervalo:</p>
                     {[1000, 2000, 3000, 4000, 5000, 8000, 10000].map(ms => (<label key={ms} className='SelfieFan__Admin__Player__Deck--FanCam__Intervals__Items'><input type='radio' name="timeFC" checked={player.autoPlayIntervalFC === ms} onChange={() => player.setAutoPlayIntervalFC(ms)}/> {ms/1000}s</label>))}
                   </div>
                   <div className='SelfieFan__Admin__Player__Deck--FanCam__Controls'>
                      <button type='button' className='SelfieFan__Admin__Player__Deck--FanCam__Controls__Buttons Btn__Adsl--RedOutlineTransparent' onClick={player.playPrev}><i className="bi bi-caret-left-fill"></i> Anterior</button>
                      <button type='button' className={`SelfieFan__Admin__Player__Deck--FanCam__Controls__Buttons ${isPauseIcon ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={player.togglePlay}><i className={`bi bi-${isPauseIcon ? 'pause-fill' : 'play-circle'}`}></i> Proyectar</button>
                      <button type='button' className='SelfieFan__Admin__Player__Deck--FanCam__Controls__Buttons Btn__Adsl--RedOutlineTransparent' onClick={() => player.playNext(player.activeTab)}>Siguiente <i className="bi bi-caret-right-fill"></i></button>
                   </div>
                </div>
            ) : (
                <div className='SelfieFan__Admin__Player__Deck'>
                    <button type='button' className='Btn__Adsl--RedOutlineTransparent mx-auto mt-1' onClick={handleClearScreenRequest}><i className='bi bi-x-circle'></i> Quitar de la pantalla</button>
                    <p className='SelfieFan__Admin__Player__Deck__LiveStatus'>Estatus: <i className={`bi bi-toggle-${player.isLive ? 'on text-success' : 'off'}`} onClick={handleLiveToggleRequest} title={player.isLive ? "En vivo" : "Detenido"}></i> {player.isLive ? "En vivo" : ""}</p>
                    <p className="SelfieFan__Admin__Player__Deck__Feedback">{player.projectionStatus}</p>
                    <div className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage'>
                        <button type='button' className='Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage--Lg__ArrowButtons' onClick={player.playPrev}><i className="bi bi-caret-left-fill"></i></button>
                        <div className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps'>
                            <p className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__Title'>Pantalla #1</p>
                            <div className={`SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer ${player.iaSequenceStep === 1 ? 'SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer--Active' : ''}`}>
                                {currentQItem && <img src={currentQItem.img1_thumb} className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer__Image' alt='1' key={currentQItem.img1_thumb} />}
                            </div>
                            {currentQItem && (<div className='d-flex justify-content-center mt-1'>{[0,1,2,3].map(a => (<button key={`p1-a${a}`} type="button" className={`mx-auto mb-0 ${currentQItem.anim1 === a ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={() => player.updateCurrentItemAnimation(1, a)} style={{fontSize:'0.7rem'}}>{a}</button>))}</div>)}
                            <button type='button' className={`mt-2 mx-auto ${player.iaSequenceStep === 1 && player.isLive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={() => player.triggerIaStep(1)}>Proyectar la #1</button>
                        </div>
                        <div className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps ms-3'>
                            <p className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__Title'>Pantalla #2</p>
                            <div className={`SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer ${player.iaSequenceStep === 2 ? 'SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer--Active' : ''}`}>
                                {currentQItem ? (<img src={currentQItem.img2_thumb} className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer__Image' alt='2' key={currentQItem.img2_thumb} />) : <span className="text-muted">Set</span>}
                            </div>
                            {currentQItem && (<div className='d-flex justify-content-center mt-1'>{[0,1,2,3].map(a => (<button key={`p2-a${a}`} type="button" className={`mx-auto mb-0 ${currentQItem.anim2 === a ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={() => player.updateCurrentItemAnimation(2, a)} style={{fontSize:'0.7rem'}}>{a}</button>))}</div>)}
                            <button type='button' className={`mt-2 mx-auto ${player.iaSequenceStep === 2 && player.isLive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={() => player.triggerIaStep(2)}>Proyectar la #2</button>
                        </div>
                        <button type='button' className='Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage--Lg__ArrowButtons' onClick={() => player.playNext('IA')}><i className="bi bi-caret-right-fill"></i></button>
                    </div>
                </div>
            )}

            {/* --- LISTA DE REPRODUCCIÓN (PLAYLIST Y TABS) --- */}
            <div className='SelfieFan__Admin__Player__Playlist'>
              <div className='SelfieFan__Admin__Player__Playlist__Tabs'>
                <button type='button' className={`${player.activeTab === 'FC' ? 'Btn__Adsl--Red bi bi-check-circle-fill' : 'Btn__Adsl--RedOutlineTransparent'} SelfieFan__Admin__Player__Playlist__Tabs__Buttons`} onClick={() => player.setActiveTab('FC')}> Fan Cam</button>
                <button type='button' className={`${player.activeTab === 'ST' ? 'Btn__Adsl--Red bi bi-check-circle-fill' : 'Btn__Adsl--RedOutlineTransparent'} SelfieFan__Admin__Player__Playlist__Tabs__Buttons`} onClick={() => player.setActiveTab('ST')}> Staff</button>
                <button type='button' className={`${player.activeTab === 'IA' ? 'Btn__Adsl--Red bi bi-check-circle-fill' : 'Btn__Adsl--RedOutlineTransparent'} SelfieFan__Admin__Player__Playlist__Tabs__Buttons`} onClick={() => player.setActiveTab('IA')}> IA</button>
              </div>
              <div className='SelfieFan__Admin__Player__Playlist__Photos'>
                <div className='SelfieFan__Admin__Player__Playlist__Photos__List'>
                    {player.queues[player.activeTab].map((item, idx) => {
                        const isCurrent = idx === player.currentIndex[player.activeTab];
                        const showArrows = player.queues[player.activeTab].length > 1;
                        return (
                          <div key={item._queueId || idx} className={`SelfieFan__Admin__Player__Playlist__Photos__List__Items ${isCurrent ? 'Btn__Adsl--RedOutline' : 'Btn__Adsl--RedOutlineTransparent'} ${item.isHidden ? 'opacity-50' : ''}`} onClick={() => player.jumpToItem(player.activeTab, idx)}>
                            <div className='d-flex align-items-center flex-grow-1'>
                                <div className='d-flex flex-column me-2 justify-content-center'>
                                    <button type='button' className='btn btn-sm border-0' onClick={(e) => { e.stopPropagation(); handleDeleteFromQueueRequest(idx); }}><i className='bi bi-trash'></i></button>
                                </div>
                                <img src={(player.activeTab === 'FC' || player.activeTab === 'ST') ? item.thumbUrl : item.img1_thumb} style={{ width: '50px', height: '50px', objectFit:'cover' }} alt="" className="rounded me-2" key={item.thumbUrl} />
                                <small className="text-truncate" style={{maxWidth: '100px'}}>{(player.activeTab === 'FC' || player.activeTab === 'ST') ? `Foto #${item.index || '?'}` : `Set #${idx+1}`}</small>
                            </div>
                            {showArrows && (
                                <div className='d-flex flex-column ms-2'>
                                    <button type='button' className='btn btn-sm p-0' onClick={(e) => { e.stopPropagation(); player.reorderQueue(player.activeTab, idx, idx-1); }}><i className='bi bi-arrow-up'></i></button>
                                    <button type='button' className='btn btn-sm p-0' onClick={(e) => { e.stopPropagation(); player.reorderQueue(player.activeTab, idx, idx+1); }}><i className='bi bi-arrow-down'></i></button>
                                </div>
                            )}
                          </div>
                        )
                    })}
                </div>
              </div>
              {player.queues[player.activeTab].length > 0 && (<button type="button" className="Btn__Adsl--RedOutlineTransparent mt-4" title={`Vaciar fila de ${player.activeTab}`} onClick={() => { setModalType(types.CLEAR_QUEUE); setShowConfirmModal(true); }}><i className="bi bi-trash3-fill"></i> Borrar lista de reproducción</button>)}
            </div>
          </div>
        </div>

        {/* ===================== SECCIÓN 2: BIBLIOTECA FAN CAM ===================== */}
        <div className="SelfieFan__Admin__Section">
          <div className="d-flex justify-content-between align-items-center mb-2 px-3">
             <div className="d-flex align-items-center">
                 {/* <img src="/img/selfiefan/Adsl-FanCam.png" className="SelfieFan__Admin__Section__Logo me-3" alt="" /> */}
                 <p className="SelfieFan__Admin__Title mb-0">Selfie Fan</p>
             </div>
             <div className="d-flex align-items-center">
                 <span className="me-2 text-white small">Ordenar:</span>
                 <div className="btn-group btn-group-sm">
                     <button type="button" className={`btn ${sortConfig.FC === 'ASC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('FC', 'ASC')}>Ascendente</button>
                     <button type="button" className={`btn ${sortConfig.FC === 'DESC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('FC', 'DESC')}>Descendente</button>
                 </div>
             </div>
          </div>

          <p className="text-center">Total de fotos: {fan.items.length}</p>
          <button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => setIsFanCollapsed(c => !c)}>{isFanCollapsed ? "Mostrar" : "Ocultar"} <i className={`bi ${isFanCollapsed ? "bi-caret-down-fill" : "bi-caret-up-fill"}`}></i></button>
          <div ref={fanCollapsibleRef} className="Collapsible">
            <div ref={fanContainerRef}>
              {fan.items.length > 0 && (
                <p className="SelfieFan__Admin__Text--Center">Selecciona la foto que deseas mostrar en pantalla:</p>
              )}
              <div className="flex gap-2 justify-center mt-3 mb-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_fan")} disabled={fan.loading}>{fan.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
              {fan.items.length === 0 ? (<p className="SelfieFan__Admin__Text--Center">Actualmente no hay fotos</p>) : (
                <>
                  <div className="SelfieFan__Admin__List">
                    {getSortedItems(fan.items, 'FC').map((it, index) => (
                      <div key={it.id} className={`SelfieFan__Admin__List__Item ${it.isSelected ? "SelfieFan__Admin__List__Item--Active" : ""} ${it.isHidden ? "opacity-50" : ""}`} style={it.wasShown ? {position: 'relative'} : {}}>
                        {it.wasShown && <span style={{position:'absolute', top:'5px', right:'5px', background:'#0d6efd', color:'white', borderRadius:'50%', padding:'2px', fontSize:'12px', width:'20px', height:'20px', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10}} title="Ya mostrada"><i className="bi bi-check-lg"></i></span>}
                        <div className="SelfieFan__Admin__List__Item__Buttons">
                          <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => handleAddToQueueSingle(it)} title="Agregar a la fila" disabled={it.isHidden}><i className="bi bi-music-note-list"></i></button>
                          <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => apiRotate(it.id)} title="Rotar" disabled={it.isHidden}><i className="bi bi-arrow-clockwise"></i></button>
                          <button type="button" className={`Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button ${it.isHidden ? 'text-warning' : ''}`} onClick={() => apiToggleHide(it.id)} title={it.isHidden ? "Mostrar" : "Ocultar"}><i className={`bi ${it.isHidden ? 'bi-eye-slash-fill' : 'bi-eye'}`}></i></button>
                          {it.contentUrl && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => handleDirectDownload(it, it.index || index + 1)} title="Descargar"><i className="bi bi-download"></i></button>)}
                          {!it.isSelected && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => ShowConfirmModalLegacy(it, types.DELETE)} title="Eliminar" disabled={it.isHidden}><i className="bi bi-trash"></i></button>)}
                        </div>
                        <p>#{it.index || '?'}</p>
                        <img src={it.thumbUrl} className="SelfieFan__Admin__Image--Normal" alt={it.caption} loading="lazy" key={it.thumbUrl} />
                        <p>Fecha: {FormatDateToMexico(it.createdAtUtc)}</p>
                        {it.isSelected ? (<button type="button" className="Btn__Adsl--Success" onClick={() => ShowConfirmModalLegacy(it, types.DESELECT)}><i className="bi bi-x-circle"></i> Quitar de la pantalla</button>) : (<button type="button" className="Btn__Adsl--RedOutlineTransparent" onClick={() => ShowConfirmModalLegacy(it, types.SELECT)} disabled={it.isHidden}><i className="bi bi-tv"></i> Mostrar en pantalla ahora</button>)}
                      </div>
                    ))}
                  </div>
                </>
              )}
              <div className="flex gap-2 justify-center mt-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_fan")} disabled={fan.loading}>{fan.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
            </div>
          </div>
        </div>

        {/* ===================== SECCIÓN 3: BIBLIOTECA STAFF CAM ===================== */}
        <div className="SelfieFan__Admin__Section">
          <div className="d-flex justify-content-between align-items-center mb-2 px-3">
             <div className="d-flex align-items-center">
                 {/* <img src="/img/selfiefan/Adsl-FanCam.png" className="SelfieFan__Admin__Section__Logo me-3" alt="" /> */}
                 <p className="SelfieFan__Admin__Title mb-0">Selfie Staff</p>
             </div>
             <div className="d-flex align-items-center">
                 <span className="me-2 text-white small">Ordenar:</span>
                 <div className="btn-group btn-group-sm">
                     <button type="button" className={`btn ${sortConfig.ST === 'ASC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('ST', 'ASC')}>Ascendente</button>
                     <button type="button" className={`btn ${sortConfig.ST === 'DESC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('ST', 'DESC')}>Descendente</button>
                 </div>
             </div>
          </div>

          <p className="text-center">Total de fotos: {staff.items.length}</p>
          <button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => setIsStaffCollapsed(c => !c)}>{isStaffCollapsed ? "Mostrar" : "Ocultar"} <i className={`bi ${isStaffCollapsed ? "bi-caret-down-fill" : "bi-caret-up-fill"}`}></i></button>
          <div ref={staffCollapsibleRef} className="Collapsible">
            <div ref={staffContainerRef}>
              {staff.items.length > 0 && (
                <p className="SelfieFan__Admin__Text--Center">Selecciona la foto que deseas mostrar en pantalla:</p>
              )}
              <div className="flex gap-2 justify-center mt-3 mb-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_staff")} disabled={staff.loading}>{staff.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
              {staff.items.length === 0 ? (<p className="SelfieFan__Admin__Text--Center">Actualmente no hay fotos</p>) : (
                <>
                  <div className="SelfieFan__Admin__List">
                    {getSortedItems(staff.items, 'ST').map((it, index) => (
                      <div key={it.id} className={`SelfieFan__Admin__List__Item ${it.isSelected ? "SelfieFan__Admin__List__Item--Active" : ""} ${it.isHidden ? "opacity-50" : ""}`} style={it.wasShown ? {position: 'relative'} : {}}>
                        {it.wasShown && <span style={{position:'absolute', top:'5px', right:'5px', background:'#0d6efd', color:'white', borderRadius:'50%', padding:'2px', fontSize:'12px', width:'20px', height:'20px', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10}} title="Ya mostrada"><i className="bi bi-check-lg"></i></span>}
                        <div className="SelfieFan__Admin__List__Item__Buttons">
                          <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => handleAddToQueueSingle(it)} title="Agregar a la fila" disabled={it.isHidden}><i className="bi bi-music-note-list"></i></button>
                          <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => apiRotate(it.id)} title="Rotar" disabled={it.isHidden}><i className="bi bi-arrow-clockwise"></i></button>
                          <button type="button" className={`Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button ${it.isHidden ? 'text-warning' : ''}`} onClick={() => apiToggleHide(it.id)} title={it.isHidden ? "Mostrar" : "Ocultar"}><i className={`bi ${it.isHidden ? 'bi-eye-slash-fill' : 'bi-eye'}`}></i></button>
                          {it.contentUrl && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => handleDirectDownload(it, it.index || index + 1)} title="Descargar"><i className="bi bi-download"></i></button>)}
                          {!it.isSelected && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => ShowConfirmModalLegacy(it, types.DELETE)} title="Eliminar" disabled={it.isHidden}><i className="bi bi-trash"></i></button>)}
                        </div>
                        <p>#{it.index || '?'}</p>
                        <img src={it.thumbUrl} className="SelfieFan__Admin__Image--Normal" alt={it.caption} loading="lazy" key={it.thumbUrl} />
                        <p>Fecha: {FormatDateToMexico(it.createdAtUtc)}</p>
                        {it.isSelected ? (<button type="button" className="Btn__Adsl--Success" onClick={() => ShowConfirmModalLegacy(it, types.DESELECT)}><i className="bi bi-x-circle"></i> Quitar de la pantalla</button>) : (<button type="button" className="Btn__Adsl--RedOutlineTransparent" onClick={() => ShowConfirmModalLegacy(it, types.SELECT)} disabled={it.isHidden}><i className="bi bi-tv"></i> Mostrar en pantalla ahora</button>)}
                      </div>
                    ))}
                  </div>
                </>
              )}
              <div className="flex gap-2 justify-center mt-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_staff")} disabled={staff.loading}>{staff.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
            </div>
          </div>
        </div>

        {/* ===================== SECCIÓN 4: BIBLIOTECA FAN CAM IA ===================== */}
        <div className="SelfieFan__Admin__Section">
          <div className="d-flex justify-content-between align-items-center mb-2 px-3">
             <div className="d-flex align-items-center">
                 {/* <img src="/img/selfiefan/IADSL.png" className="SelfieFan__Admin__Section__Logo me-3" alt="" /> */}
                 <p className="SelfieFan__Admin__Title mb-0">Selfie Fan con IA</p>
             </div>
             <div className="d-flex align-items-center">
                 <span className="me-2 text-white small">Ordenar:</span>
                 <div className="btn-group btn-group-sm">
                     <button type="button" className={`btn ${sortConfig.IA === 'ASC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('IA', 'ASC')}>Ascendente</button>
                     <button type="button" className={`btn ${sortConfig.IA === 'DESC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('IA', 'DESC')}>Descendente</button>
                 </div>
             </div>
          </div>

          <p className="text-center">Total de fotos: {ia.items.length}</p>
          <button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => setIsIACollapsed(c => !c)}>{isIACollapsed ? "Mostrar" : "Ocultar"} <i className={`bi ${isIACollapsed ? "bi-caret-down-fill" : "bi-caret-up-fill"}`}></i></button>
          <div ref={iaCollapsibleRef} className="Collapsible">
            <div ref={iaContainerRef}>
              <div className="flex gap-2 justify-center mt-3 mb-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_ia")} disabled={ia.loading}>{ia.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
              {ia.items.length === 0 ? (<p className="SelfieFan__Admin__Text--Center">Actualmente no hay fotos con IA</p>) : (
                <>
                  <div className="SelfieFanIA__Admin__FakeScreen">
                    <div className="SelfieFanIA__Admin__FakeScreen__Squares">
                      <div className="SelfieFanIA__Admin__FakeScreen__Squares__Screens">
                        <p>Pantalla #1</p>
                        <img src={(() => { const id = selectedForScreen[1]; const found = ia.items.find(x => x.id === id); return found ? found.thumbUrl : "/img/page/Fondo-Azul-Five-Screen.png"; })()} className="SelfieFanIA__Admin__FakeScreen__Squares__Screens__Image" alt="P1" key={selectedForScreen[1] ? ia.items.find(x => x.id === selectedForScreen[1])?.thumbUrl : 'def1'} />
                        <div className="SelfieFanIA__Admin__FakeScreen__Squares__Screens__EffectButtons">{[0,1,2,3].map(anim => (<button key={`anim1-${anim}`} type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__Squares__Screens__EffectButtons__Buttons", animationByScreen[1] === anim)} onClick={() => setAnimationForScreen(1, anim)} disabled={!selectedForScreen[1]}>{anim === 0 ? "Ninguno" : anim}</button>))}</div>
                      </div>
                      <div className="SelfieFanIA__Admin__FakeScreen__Squares__Screens">
                        <p>Pantalla #2</p>
                         <img src={(() => { const id = selectedForScreen[2]; const found = ia.items.find(x => x.id === id); return found ? found.thumbUrl : "/img/page/Fondo-Azul-Five-Screen.png"; })()} className="SelfieFanIA__Admin__FakeScreen__Squares__Screens__Image" alt="P2" key={selectedForScreen[2] ? ia.items.find(x => x.id === selectedForScreen[2])?.thumbUrl : 'def2'} />
                        <div className="SelfieFanIA__Admin__FakeScreen__Squares__Screens__EffectButtons">{[0,1,2,3].map(anim => (<button key={`anim2-${anim}`} type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__Squares__Screens__EffectButtons__Buttons", animationByScreen[2] === anim)} onClick={() => setAnimationForScreen(2, anim)} disabled={!selectedForScreen[2]}>{anim === 0 ? "Ninguno" : anim}</button>))}</div>
                      </div>
                    </div>
                    <div className="SelfieFanIA__Admin__FakeScreen__ActionButtons">
                      <button type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__ActionButtons__Buttons", activeShowAction === "screen1")} disabled={!selectedForScreen[1]} onClick={() => ShowConfirmModalLegacy(null, types.IA_SHOW1)}>Proyectar pantalla #1</button>
                      <button type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__ActionButtons__Buttons", activeShowAction === "screen2")} disabled={!selectedForScreen[1] || !selectedForScreen[2]} onClick={() => ShowConfirmModalLegacy(null, types.IA_SHOW_BOTH)}>Proyectar pantalla #2</button>
                      <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__ActionButtons__Buttons" onClick={() => ShowConfirmModalLegacy(null, types.IA_CLEAR)} disabled={isClearingIA}>Quitar de la pantalla</button>
                      <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__ActionButtons__Buttons" onClick={handleAddSetToQueueIA} disabled={!selectedForScreen[1] || !selectedForScreen[2]} style={{ marginTop: '10px' }}><i className="bi bi-music-note-list"></i> Agregar set a la fila</button>
                    </div>
                  </div>

                  <div className="SelfieFanIA__Admin__List">
                    {getSortedItems(ia.items, 'IA').map((it, index) => {
                      const isFor1 = selectedForScreen[1] === it.id; const isFor2 = selectedForScreen[2] === it.id; const selectedForAny = isFor1 || isFor2;
                      return (
                        <div key={it.id} className={`SelfieFan__Admin__List__Item ${it.isSelected ? "SelfieFan__Admin__List__Item--Active" : ""} ${it.isHidden ? "opacity-50" : ""}`} style={it.wasShown ? {position: 'relative'} : {}}>
                          {it.wasShown && <span style={{position:'absolute', top:'5px', right:'5px', background:'#0d6efd', color:'white', borderRadius:'50%', padding:'2px', fontSize:'12px', width:'20px', height:'20px', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10}} title="Ya mostrada"><i className="bi bi-check-lg"></i></span>}
                          <div className="SelfieFan__Admin__List__Item__Buttons">
                            {it.contentUrl && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => handleDirectDownload(it, it.index || index + 1)}><i className="bi bi-download"></i></button>)}
                            <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => apiRotate(it.id)} title="Rotar" disabled={it.isHidden}><i className="bi bi-arrow-clockwise"></i></button>
                            <button type="button" className={`Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button ${it.isHidden ? 'text-warning' : ''}`} onClick={() => apiToggleHide(it.id)} title={it.isHidden ? "Mostrar" : "Ocultar"}><i className={`bi ${it.isHidden ? 'bi-eye-slash-fill' : 'bi-eye'}`}></i></button>
                            {(!it.isSelected && !selectedForAny) && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => ShowConfirmModalLegacy({ ...it, source: "selfie_ia" }, types.DELETE)} disabled={it.isHidden}><i className="bi bi-trash"></i></button>)}
                          </div>
                          <p>#{it.index || '?'}</p>
                          <img src={it.thumbUrl} className="SelfieFan__Admin__Image--Normal" alt="img" key={it.thumbUrl} />
                          <div className="SelfieFan__Admin__List__Item__Buttons">
                             <button type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent mx-auto", isFor1)} disabled={selectedForScreen[2] === it.id || it.isHidden} onClick={() => toggleCardForScreen(1, it.id)}><i className="bi bi-plus-circle"></i> Agregar a Pantalla #1</button>
                             <button type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent mx-auto", isFor2)} disabled={selectedForScreen[1] === it.id || it.isHidden} onClick={() => toggleCardForScreen(2, it.id)}><i className="bi bi-plus-circle"></i> Agregar a Pantalla #2</button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
              <div className="flex gap-2 justify-center mt-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_ia")} disabled={ia.loading}>{ia.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
            </div>
          </div>
        </div>

        {/* ===================== SECCIÓN 5: OVERLAY Y TRACKPAD ===================== */}
        <div className="SelfieFan__Admin__Section">
          <p className="SelfieFan__Admin__Title">Overlay Selfie Fan</p>
          <button type="button" className="Btn__Adsl--RedOutlineTransparent d-block mx-auto mt-2" onClick={handleShowQROverlay}>
            <i className="bi bi-qr-code"></i> Proyectar QR de selfiefan en overlay
          </button>

          <button type="button" className="Btn__Adsl--RedOutlineTransparent d-block mx-auto mt-2" onClick={handleShowMessagesQROverlay}>
            <i className="bi bi-qr-code"></i> Proyectar QR de MENSAJES en overlay
          </button>
          
          <div className="card shadow-sm mb-4 border-danger mt-4" style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'transparent' }}>
            <div className="card-header bg-danger text-white font-weight-bold d-flex justify-content-between align-items-center">
                <span><i className="bi bi-display me-2"></i> Configuración de Overlay - Establece la posición de la imagen en el overlay</span>
                <div className="d-flex align-items-center gap-2"></div>
            </div>
            
            <div className="card-body">
                {hasUnsavedChanges && (
                    <div className="alert alert-warning py-2 mb-4 text-center small">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        Tienes cambios sin guardar. Presiona <strong>"Guardar"</strong> para mantenerlos la próxima vez.
                    </div>
                )}

                <div className="d-flex justify-content-between align-items-center mb-1">
                    <p className="font-weight-bold mb-0 text-center"><i className="bi bi-arrows-move me-1"></i> Trackpad Virtual de Posición</p>
                    <span className={`badge ${isOverlaySyncing ? 'bg-warning text-dark' : 'bg-transparent text-muted'}`}>
                        {isOverlaySyncing ? 'Enviando a pantalla...' : ''}
                    </span>
                </div>
                
                <p className="small text-muted mb-3">Arrastra el recuadro rojo con tu dedo o mouse para mover la imagen dinámicamente.</p>
                
                <div className="d-flex justify-content-center">
                    <div 
                        style={{
                            width: '100%', maxWidth: '400px', height: '225px', backgroundColor: '#1a1a1a', 
                            position: 'relative', overflow: 'hidden', borderRadius: '12px', border: '2px solid #444',
                            boxShadow: 'inset 0 0 20px rgba(0,0,0,0.8)', touchAction: 'none', 
                            cursor: isDraggingTrackpad ? 'grabbing' : 'grab'
                        }}
                        onPointerDown={handleTrackpadPointerDown} onPointerMove={handleTrackpadPointerMove}
                        onPointerUp={handleTrackpadPointerUp} onPointerCancel={handleTrackpadPointerUp} onPointerLeave={handleTrackpadPointerUp}
                    >
                        <div style={{
                            position: 'absolute', right: `${(overlayX / 1700) * 85}%`, bottom: `${(overlayY / 700) * 80}%`,
                            width: '15%', height: '20%', backgroundColor: isDraggingTrackpad ? 'rgba(255, 0, 0, 0.9)' : 'rgba(255, 0, 0, 0.5)',
                            border: '2px solid #ff4d4d', borderRadius: '4px', transform: `scale(${overlayScale})`,
                            transformOrigin: 'bottom right', pointerEvents: 'none', display: 'flex',
                            justifyContent: 'center', alignItems: 'center', transition: isDraggingTrackpad ? 'none' : 'all 0.1s ease-out'
                        }}>
                            <i className="bi bi-camera text-white" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        <div style={{ position: 'absolute', top: '50%', left: 0, right: 0, borderTop: '1px dashed #333', pointerEvents: 'none' }}></div>
                        <div style={{ position: 'absolute', left: '50%', top: 0, bottom: 0, borderLeft: '1px dashed #333', pointerEvents: 'none' }}></div>
                    </div>
                </div>

                <button type="button" className={`mx-auto d-block mt-4 Btn__Adsl--RedOutlineTransparent mb-0`} onClick={handleSaveOverlayConfig}>
                  <i className="bi bi-save"></i> Guardar configuraciones
                </button>
                {!hasUnsavedChanges && lastSavedDate && (
                  <div className="text-center mb-3">
                    <small className="text-success">Último guardado: {FormatDateToMexico(lastSavedDate)}</small>
                  </div>
                )}

                <hr className="my-4 border-secondary" />
                
                <p className='text-center'>¿No se visualizan en pantalla las configuraciones que estableciste?</p>
                <button type="button" className="Btn__Adsl--RedOutlineTransparent d-block mx-auto" onClick={handleApplyOverlayToScreen} disabled={isOverlaySyncing}>
                  <i className="bi bi-tv"></i> Aplicar configuraciones ahora
                </button>

                <hr className="my-4 border-secondary" />

                <p className="small text-muted mb-3">Establece los valores numéricos que deseas para la imagen del overlay.</p>

                <div className="row mb-4">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label font-weight-bold d-flex justify-content-between">
                                <span>Mover Horizontal (X):</span>
                            </label>
                            <div className="d-flex align-items-center">
                                <input type="range" className="form-range flex-grow-1 me-3" min="0" max="1700" step="10" value={overlayX} onChange={(e) => setOverlayX(parseInt(e.target.value))} />
                                <input type="number" className="form-control form-control-sm text-center bg-dark text-white border-secondary p-0" style={{ width: '120px' }} value={overlayX} onChange={(e) => setOverlayX(parseInt(e.target.value) || 0)} /><span className='ms-1'>px</span>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label font-weight-bold d-flex justify-content-between">
                                <span>Mover Vertical (Y):</span>
                            </label>
                            <div className="d-flex align-items-center">
                                <input type="range" className="form-range flex-grow-1 me-3" min="0" max="700" step="10" value={overlayY} onChange={(e) => setOverlayY(parseInt(e.target.value))} />
                                <input type="number" className="form-control form-control-sm text-center bg-dark text-white border-secondary p-0" style={{ width: '120px' }} value={overlayY} onChange={(e) => setOverlayY(parseInt(e.target.value) || 0)} /><span className='ms-1'>px</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 border-start border-secondary d-flex flex-column justify-content-center">
                        <label className="form-label font-weight-bold d-flex justify-content-between">
                            <span>Tamaño (Escala):</span>
                        </label>
                        <div className="d-flex align-items-center mb-2">
                            <input type="range" className="form-range flex-grow-1 me-3" min="0.3" max="2.5" step="0.1" value={overlayScale} onChange={(e) => setOverlayScale(parseFloat(e.target.value))} />
                            <input type="number" className="form-control form-control-sm text-center bg-dark text-white border-secondary p-0" style={{ width: '120px' }} step="0.1" value={overlayScale} onChange={(e) => setOverlayScale(parseFloat(e.target.value) || 1)} />
                        </div>
                        <small className="text-muted text-center"><i className="bi bi-info-circle"></i> 1.0 = Tamaño Original (Max 250px)</small>
                    </div>
                </div>

                <button type="button" className={`mx-auto d-block mt-4 Btn__Adsl--RedOutlineTransparent mb-0`} onClick={handleSaveOverlayConfig}>
                  <i className="bi bi-save"></i> Guardar configuraciones
                </button>
            </div>
          </div>
        </div>

        {/* ... Modales ... */}
        {showConfirmModal && (
          <>
             {modalType === types.CONFIRM_START_LIVE && (<Confirm message="¿Deseas iniciar la proyección a la pantalla grande?" actionToYesButton={confirmLiveAction} textYesButton="Sí, iniciar" textNoButton="Cancelar" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.CONFIRM_STOP_LIVE && (<Confirm message="¿Deseas detener la proyección?" actionToYesButton={confirmLiveAction} textYesButton="Sí, detener" textNoButton="Cancelar" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.PLAYER_CLEAR && (<Confirm message="¿Estás seguro de detener la proyección y limpiar la pantalla grande?" actionToYesButton={confirmClearScreen} textYesButton="Sí, limpiar" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.DELETE_FROM_QUEUE && (<Confirm message="¿Deseas quitar esta foto de la fila de reproducción?" actionToYesButton={confirmDeleteFromQueue} textYesButton="Sí, quitar" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.CLEAR_QUEUE && (<Confirm message={`¿Estás seguro de eliminar toda la fila de reproducción ${player.activeTab === 'FC' ? 'de Fan Cam' : player.activeTab === 'ST' ? 'de Staff' : 'Fan Cam con IA'}? (Esta acción no se puede deshacer)`} actionToYesButton={confirmClearQueue} textYesButton="Sí, eliminar todo" textNoButton="Cancelar" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             
             {modalType === types.SELECT && (<Confirm message={`¿Estás segur@ de proyectar en la pantalla la Selfie Fan (${selfie?.index || selfie?.id})?`} image={selfie?.thumbUrl} actionToYesButton={SelectSelfie} textYesButton="Sí, proyectar ahora" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.DESELECT && (<Confirm message={`¿Estás segur@ de quitar de la pantalla la Selfie Fan (${selfie?.index || selfie?.id})?`} image={selfie?.thumbUrl} actionToYesButton={DeselectSelfie} textYesButton="Sí, quitar ahora" textNoButton={"No"} setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.DELETE && (<Confirm message={`¿Estás segur@ de eliminar la Selfie (${selfie?.index || selfie?.id})?`} image={selfie?.thumbUrl} actionToYesButton={DeleteSelfie} textYesButton="Sí, eliminar" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.RESET && (<Confirm message="¿Estás segur@ de reiniciar la dinámica completa?" image={null} actionToYesButton={ResetDinamyc} textYesButton="Sí, reiniciar ahora" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.IA_SHOW1 && (<Confirm message="¿Deseas proyectar solo la Pantalla #1?" image={null} actionToYesButton={() => SendSelfiesFanIAToScreen([1])} textYesButton="Sí, proyectar 1" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.IA_SHOW_BOTH && (<Confirm message="¿Deseas proyectar la Pantalla #1 y #2?" image={null} actionToYesButton={() => SendSelfiesFanIAToScreen([1,2])} textYesButton="Sí, proyectar 1 y 2" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             {modalType === types.IA_CLEAR && (<Confirm message="¿Deseas quitar las imágenes de la pantalla grande?" image={null} actionToYesButton={ClearSelfiesFanIAFromScreen} textYesButton="Sí, quitar ahora" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
          </>
        )}

      </SecondaryBase>
    </div>
  );
};

export { SelfieFanPlayer };









// Funcional
// import { useEffect, useState, useRef, useLayoutEffect } from 'react'
// import { 
//     GetAllSelfies as BLGetAllSelfies, 
//     SelectSelfie as BLSelectSelfie, 
//     DeselectSelfie as BLDeselectSelfie, 
//     DeleteSelfie as BLDeleteSelfie, 
//     ResetDinamyc as BLResetDinamyc, 
//     FormatDateToMexico, 
//     GetSelfiesPage as BLGetSelfiesPage, 
//     SendSelfiesFanIAToScreen as BLSendSelfiesFanIAToScreen, 
//     DeselectSelfieFanIA as BLDeselectSelfieFanIA, 
//     UpdateOverlayPositionAndScale as BLUpdateOverlayPositionAndScale,
//     GetOverlaySettings as BLGetOverlaySettings,
//     SaveOverlaySettings as BLSaveOverlaySettings,
//     SendQRToOverlay as BLSendQRToOverlay
// } from './../../../utilities/BL/SelfieFan'
// import { Loading } from '../../Commons/Loading'
// import { SecondaryBase } from '../Commons/SecondaryBase'
// import { ResetCurrentDynamic as BLResetCurrentDynamic } from './../../../utilities/BL/Zones'

// import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'
// import { Confirm } from './../../Commons/Modals/Confirm'
// import { FormatDateTimeToDownloadImages as BLFormatDateTimeToDownloadImages } from './../../../utilities/BL/Commons/DatesAndTimes'

// import { useSelfiePlayer } from './SelfieFanPlayer/useSelfieFanPlayer'

// // ==============================================================================
// // CONFIGURACIÓN Y CONSTANTES GLOBALES
// // ==============================================================================

// const PAGE_SIZE = 30; 

// // Tipos de Acción para el manejo de Modales
// const types = {
//   SELECT: 1, DESELECT: 2, DELETE: 3, RESET: 4,
//   IA_SHOW1: "IA_SHOW1", IA_SHOW_BOTH: "IA_SHOW_BOTH", IA_CLEAR: "IA_CLEAR",
//   PLAYER_CLEAR: "PLAYER_CLEAR",
//   CONFIRM_START_LIVE: "CONFIRM_START_LIVE",
//   CONFIRM_STOP_LIVE: "CONFIRM_STOP_LIVE",
//   DELETE_FROM_QUEUE: "DELETE_FROM_QUEUE",
//   CLEAR_QUEUE: "CLEAR_QUEUE"
// };

// const initialPagedState = {
//   items: [],
//   nextCursor: null,
//   loading: false,
//   exhausted: false,
// };

// // ==============================================================================
// // COMPONENTE PRINCIPAL: SelfieFanPlayer
// // ==============================================================================
// const SelfieFanPlayer = ({ getOutOfTheDynamic }) => {
//   const { showMessage } = useFloatMessage();

//   // ----------------------------------------------------------------------------
//   // 1. CONEXIÓN CON EL CEREBRO
//   // ----------------------------------------------------------------------------
//   const playerActions = {
//     sendToScreenFC: async (item) => {
//       const resp = await BLSelectSelfie(item);
//       if (!resp.success) throw new Error(resp.message);
//       return resp;
//     },
//     sendToScreenIA: async (payload) => {
//       const resp = await BLSendSelfiesFanIAToScreen(payload);
//       if (!resp.success) throw new Error(resp.message);
//       return resp;
//     },
//     clearScreen: async () => {
//       await BLDeselectSelfie();
//       await BLDeselectSelfieFanIA();
//     }
//   };

//   const handleItemShown = (id) => {
//       setFan(prev => ({...prev, items: prev.items.map(x => x.id === id ? { ...x, wasShown: true } : x)}));
//       setIA(prev => ({...prev, items: prev.items.map(x => x.id === id ? { ...x, wasShown: true } : x)}));
//   };

//   const player = useSelfiePlayer(playerActions, showMessage, handleItemShown);

//   // ----------------------------------------------------------------------------
//   // 2. ESTADOS VISUALES LOCALES
//   // ----------------------------------------------------------------------------
//   const [isLoading, setIsLoading] = useState(true);
  
//   const [sortConfig, setSortConfig] = useState({ FC: 'DESC', IA: 'DESC' });

//   // Modales
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [modalType, setModalType] = useState(null);
//   const [modalData, setModalData] = useState(null);
//   const [selfie, setSelfie] = useState(null); 

//   // Datos
//   const [fan, setFan] = useState({ ...initialPagedState }); 
//   const [ia, setIA]   = useState({ ...initialPagedState }); 

//   // UI IA
//   const [selectedForScreen, setSelectedForScreen] = useState({ 1: null, 2: null });
//   const [animationByScreen, setAnimationByScreen] = useState({ 1: 0, 2: 0 });
//   const [activeShowAction, setActiveShowAction]   = useState(null); 
//   const [isClearingIA, setIsClearingIA]           = useState(false);

//   // Colapsables
//   const fanContainerRef = useRef(null);
//   const iaContainerRef  = useRef(null);
//   const fanCollapsibleRef = useRef(null);
//   const iaCollapsibleRef  = useRef(null);
//   const [isFanCollapsed, setIsFanCollapsed] = useState(false);
//   const [isIACollapsed, setIsIACollapsed]   = useState(false);

//   // ============================================================================
//   // ESTADOS Y REFERENCIAS PARA OVERLAY Y TRACKPAD
//   // ============================================================================
//   const [overlayX, setOverlayX] = useState(0);
//   const [overlayY, setOverlayY] = useState(0);
//   const [overlayScale, setOverlayScale] = useState(1.0);
  
//   // Estados para Gestión de Guardado (BD)
//   const [savedConfig, setSavedConfig] = useState({ x: 0, y: 0, scale: 1.0 });
//   const [lastSavedDate, setLastSavedDate] = useState(null);
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
//   const [isOverlayLoaded, setIsOverlayLoaded] = useState(false); 
//   const isFirstRenderForOverlay = useRef(true);

//   // Variables para la física del Drag & Drop y Sincronización en vivo
//   const [isOverlaySyncing, setIsOverlaySyncing] = useState(false);
//   const [isDraggingTrackpad, setIsDraggingTrackpad] = useState(false);
//   const dragAnchorReference = useRef({ x: 0, y: 0, startOverlayX: 0, startOverlayY: 0 });

//   // ----------------------------------------------------------------------------
//   // EFECTO DE SINCRONIZACIÓN EN VIVO (DEBOUNCE)
//   // ----------------------------------------------------------------------------
//   useEffect(() => {
//       if (!isOverlayLoaded) return;

//       if (isFirstRenderForOverlay.current) {
//           isFirstRenderForOverlay.current = false;
//           return;
//       }

//       // Detectar si hay cambios respecto a lo guardado en BD
//       const isChanged = overlayX !== savedConfig.x || overlayY !== savedConfig.y || overlayScale !== savedConfig.scale;
//       setHasUnsavedChanges(isChanged);

//       // Si no hay cambios ni estamos arrastrando, salimos
//       if (!isChanged && !isDraggingTrackpad) return;

//       setIsOverlaySyncing(true);
//       const debounceTimer = setTimeout(async () => {
//           try {
//               await BLUpdateOverlayPositionAndScale(overlayX, overlayY, overlayScale);
//               setIsOverlaySyncing(false);
//           } catch (error) {
//               console.error("Error sincronizando overlay en vivo:", error);
//               setIsOverlaySyncing(false);
//           }
//       }, 150);

//       return () => clearTimeout(debounceTimer);
//   }, [overlayX, overlayY, overlayScale, isOverlayLoaded]); // Sin savedConfig en dependencias para evitar loops

//   // ----------------------------------------------------------------------------
//   // FUNCIONES DE OVERLAY (APLICAR, GUARDAR Y QR)
//   // ----------------------------------------------------------------------------
//   const handleApplyOverlayToScreen = async () => {
//       setIsOverlaySyncing(true);
//       try {
//           await BLUpdateOverlayPositionAndScale(overlayX, overlayY, overlayScale);
//           showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Posición enviada a la pantalla (OBS)." });
//       } catch (error) {
//           showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al enviar a la pantalla." });
//       } finally {
//           setIsOverlaySyncing(false);
//       }
//   };

//   const handleSaveOverlayConfig = async () => {
//       try {
//           const resp = await BLSaveOverlaySettings(overlayX, overlayY, overlayScale);
//           if (resp.success) {
//               setSavedConfig({ x: overlayX, y: overlayY, scale: overlayScale });
//               setHasUnsavedChanges(false);
//               setLastSavedDate(new Date());
//               showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Configuración guardada en Base de Datos." });
//           } else {
//               throw new Error(resp.message);
//           }
//       } catch (error) {
//           showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al guardar en BD." });
//       }
//   };

//   const handleShowQROverlay = async () => {
//       try {
//           const resp = await BLSendQRToOverlay();
//           if (resp.success) {
//               showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Código QR enviado a la pantalla." });
//           } else {
//               throw new Error(resp.message);
//           }
//       } catch (error) {
//           showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al enviar QR." });
//       }
//   };

//   // ----------------------------------------------------------------------------
//   // MÉTODOS DEL TRACKPAD VIRTUAL
//   // ----------------------------------------------------------------------------
//   const handleTrackpadPointerDown = (event) => {
//       setIsDraggingTrackpad(true);
//       dragAnchorReference.current = {
//           x: event.clientX || (event.touches && event.touches[0].clientX),
//           y: event.clientY || (event.touches && event.touches[0].clientY),
//           startOverlayX: overlayX,
//           startOverlayY: overlayY
//       };
//       if (event.target.setPointerCapture) {
//           event.target.setPointerCapture(event.pointerId);
//       }
//   };

//   const handleTrackpadPointerMove = (event) => {
//       if (!isDraggingTrackpad) return;

//       const currentPointerX = event.clientX || (event.touches && event.touches[0].clientX);
//       const currentPointerY = event.clientY || (event.touches && event.touches[0].clientY);
      
//       const deltaX = currentPointerX - dragAnchorReference.current.x;
//       const deltaY = currentPointerY - dragAnchorReference.current.y;

//       const dragSensitivity = 3; 

//       let calculatedNewX = Math.round(dragAnchorReference.current.startOverlayX - (deltaX * dragSensitivity));
//       let calculatedNewY = Math.round(dragAnchorReference.current.startOverlayY - (deltaY * dragSensitivity));

//       // LÍMITES REALES PARA 1920x1080 (OBS)
//       const MAX_X = 1700;
//       const MAX_Y = 700;  

//       calculatedNewX = Math.max(0, Math.min(MAX_X, calculatedNewX));
//       calculatedNewY = Math.max(0, Math.min(MAX_Y, calculatedNewY));

//       setOverlayX(calculatedNewX);
//       setOverlayY(calculatedNewY);
//   };

//   const handleTrackpadPointerUp = () => {
//       setIsDraggingTrackpad(false);
//   };

//   // ----------------------------------------------------------------------------
//   // 3. HELPERS VISUALES Y LÓGICA DE DATOS
//   // ----------------------------------------------------------------------------
//   const btnClass = (base, isActive) => `${base} ${isActive ? "Btn__Adsl--Success" : ""}`;

//   const getSortedItems = (items, type) => {
//     if (!items || items.length === 0) return [];
//     const order = sortConfig[type] || 'DESC'; 
//     return [...items].sort((a, b) => {
//         const idxA = (typeof a.index === 'number') ? a.index : 0;
//         const idxB = (typeof b.index === 'number') ? b.index : 0;
//         return order === 'ASC' ? idxA - idxB : idxB - idxA; 
//     });
//   };

//   const setOrderFor = (type, order) => {
//       setSortConfig(prev => ({ ...prev, [type]: order }));
//   };

//   const useCollapsibleParent = (parentRef, contentRef, isCollapsed) => {
//     useLayoutEffect(() => {
//       const parent = parentRef.current;
//       const content = contentRef.current;
//       if (!parent || !content) return;
//       parent.style.overflow = "hidden";
//       parent.style.transition = "max-height .25s ease";
//       const setMax = () => { parent.style.maxHeight = isCollapsed ? "0px" : `${content.scrollHeight}px`; };
//       setMax();
//       const ro = new ResizeObserver(() => { if (!isCollapsed) parent.style.maxHeight = `${content.scrollHeight}px`; });
//       ro.observe(content);
//       return () => ro.disconnect();
//     }, [parentRef, contentRef, isCollapsed]);
//   };
//   useCollapsibleParent(fanCollapsibleRef, fanContainerRef, isFanCollapsed);
//   useCollapsibleParent(iaCollapsibleRef,  iaContainerRef,  isIACollapsed);

//   const preserveScroll = (containerRef, updateFn) => {
//     const el = containerRef.current;
//     if (!el) return updateFn();
//     const prevTop = el.scrollTop;
//     const prevHeight = el.scrollHeight;
//     updateFn();
//     requestAnimationFrame(() => {
//       const newHeight = el.scrollHeight;
//       el.scrollTop = prevTop + (newHeight - prevHeight);
//     });
//   };

//   const mergePage = (prev, page) => {
//     const map = new Map(prev.items.map((x) => [x.id, x]));
//     for (const it of page.items) map.set(it.id, { ...(map.get(it.id) || {}), ...it });
//     return { items: Array.from(map.values()), nextCursor: page.nextCursor ?? null, loading: false, exhausted: !page.nextCursor };
//   };

//   const markLoading = (prev) => ({ ...prev, loading: true });

//   const loadFirstPage = async (source) => {
//     const setState = source === "selfie_fan" ? setFan : setIA;
//     setState({ ...initialPagedState, loading: true });
//     try {
//       const resp = await BLGetSelfiesPage({ source, limit: PAGE_SIZE, cursor: null });
//       if (resp.success) setState(mergePage(initialPagedState, { items: resp.data.items, nextCursor: resp.data.nextCursor }));
//     } catch (err) { setState({ ...initialPagedState, loading: false }); showMessage({ type: MESSAGE_TYPE.BAD, text: err.message }); }
//   };

//   const loadMore = async (source) => {
//     const state = source === "selfie_fan" ? fan : ia;
//     const setState = source === "selfie_fan" ? setFan : setIA;
//     const container = source === "selfie_fan" ? fanContainerRef : iaContainerRef;
//     if (state.loading) return; 
//     setState(markLoading);
//     try {
//       if (state.nextCursor) {
//         const resp = await BLGetSelfiesPage({ source, limit: PAGE_SIZE, cursor: state.nextCursor });
//         if (!resp.success) throw new Error(resp.message);
//         preserveScroll(container, () => setState((prev) => mergePage(prev, { items: resp.data.items, nextCursor: resp.data.nextCursor })));
//       } else {
//         const resp = await BLGetSelfiesPage({ source, limit: PAGE_SIZE, cursor: null });
//         if (!resp.success) throw new Error(resp.message);
//         const existingIds = new Set(state.items.map((x) => x.id));
//         const latest = state.items.length ? new Date(Math.max(...state.items.map((x) => new Date(x.createdAtUtc).getTime()))) : null;
//         const incoming = resp.data.items;
//         const onlyNew = incoming.filter((x) => !existingIds.has(x.id) && (!latest || new Date(x.createdAtUtc) > latest));
//         if (!onlyNew.length) { setState((prev) => ({ ...prev, loading: false })); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "No hay más por ahora." }); return; }
//         preserveScroll(container, () => setState(prev => ({ ...prev, items: [...prev.items, ...onlyNew], loading: false })));
//       }
//     } catch (err) { setState((prev) => ({ ...prev, loading: false })); showMessage({ type: MESSAGE_TYPE.BAD, text: err.message || "Error al cargar más." }); }
//   };

//   const loadOverlayData = async () => {
//       try {
//           const resp = await BLGetOverlaySettings();
//           if (resp && resp.success && resp.data) {
//               setOverlayX(resp.data.x);
//               setOverlayY(resp.data.y);
//               setOverlayScale(resp.data.scale);
//               setSavedConfig({ x: resp.data.x, y: resp.data.y, scale: resp.data.scale });
              
//               if(resp.data.lastSavedAt) setLastSavedDate(new Date(resp.data.lastSavedAt));
//           }
//       } catch (error) {
//           console.error("Error cargando config de overlay", error);
//       } finally {
//           setIsOverlayLoaded(true);
//       }
//   };

//   const reloadNow = async () => { 
//       await Promise.all([loadFirstPage("selfie_fan"), loadFirstPage("selfie_ia"), loadOverlayData()]); 
//       showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Listado actualizado." }); 
//   };
  
//   useEffect(() => { (async () => { await reloadNow(); setIsLoading(false); })(); }, []);
//   const ReturnToDashboard = async () => { try { await BLResetCurrentDynamic(); } finally { getOutOfTheDynamic(); } };

//   // ----------------------------------------------------------------------------
//   // 4. FUNCIONES AUXILIARES (API)
//   // ----------------------------------------------------------------------------
//   const apiRotate = async (id) => {
//     try {
//       const url = `${process.env.REACT_APP_API_URL}SelfieFan/${id}/rotate`;
//       const res = await fetch(url, { method: 'POST' });
//       if (!res.ok) throw new Error("Error al rotar");
      
//       const timestamp = new Date().getTime(); 
//       const updateImageCache = (list) => list.map(item => {
//           if (item.id !== id) return item;
//           const cleanUrl = item.thumbUrl.split('?')[0]; 
//           const newUrl = `${cleanUrl}?t=${timestamp}`;
//           return { ...item, thumbUrl: newUrl }; 
//       });

//       setFan(prev => ({ ...prev, items: updateImageCache(prev.items) }));
//       setIA(prev => ({ ...prev, items: updateImageCache(prev.items) }));
      
//       const targetItem = fan.items.find(x => x.id === id) || ia.items.find(x => x.id === id);
//       if(targetItem) {
//           const cleanUrl = targetItem.thumbUrl.split('?')[0];
//           const newUrl = `${cleanUrl}?t=${timestamp}`;
//           player.refreshItemInQueue(id, newUrl, 0); 
//       }
//       showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Imagen rotada." });
//     } catch { showMessage({ type: MESSAGE_TYPE.BAD, text: "No se pudo rotar." }); }
//   };

//   const apiToggleHide = async (id) => {
//     try {
//       const url = `${process.env.REACT_APP_API_URL}SelfieFan/${id}/toggle-hide`;
//       const res = await fetch(url, { method: 'POST' });
//       if (!res.ok) throw new Error("Error");
//       const updateVisibility = (list) => list.map(item => item.id === id ? { ...item, isHidden: !item.isHidden } : item);
//       setFan(prev => ({ ...prev, items: updateVisibility(prev.items) }));
//       setIA(prev => ({ ...prev, items: updateVisibility(prev.items) }));
//       showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Visibilidad actualizada." });
//     } catch { showMessage({ type: MESSAGE_TYPE.BAD, text: "Error al ocultar." }); }
//   };

//   const apiDownloadAll = () => {
//     const url = `${process.env.REACT_APP_API_URL}SelfieFan/download-all`;
//     window.open(url, '_blank');
//     showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Generando ZIP..." });
//   };

//   // ----------------------------------------------------------------------------
//   // 5. HANDLERS UI (Modales)
//   // ----------------------------------------------------------------------------
//   const handleLiveToggleRequest = () => { setModalType(player.isLive ? types.CONFIRM_STOP_LIVE : types.CONFIRM_START_LIVE); setShowConfirmModal(true); };
//   const confirmLiveAction = () => { player.toggleLive(!player.isLive); setShowConfirmModal(false); };
//   const handleClearScreenRequest = () => { setModalType(types.PLAYER_CLEAR); setShowConfirmModal(true); };
//   const confirmClearScreen = async () => { await player.emergencyStop(); setShowConfirmModal(false); };
//   const handleDeleteFromQueueRequest = (index) => { setModalData({ index }); setModalType(types.DELETE_FROM_QUEUE); setShowConfirmModal(true); };
//   const confirmDeleteFromQueue = () => { if (modalData && typeof modalData.index === 'number') { player.removeFromQueue(player.activeTab, modalData.index); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Eliminado." }); } setShowConfirmModal(false); };
//   const confirmClearQueue = () => { player.clearQueue(player.activeTab); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Fila vaciada." }); setShowConfirmModal(false); };
//   const handleAddToQueueFC = (item) => { if (item.isHidden) return; player.addToQueue('FC', item); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Agregado." }); };
//   const handleAddSetToQueueIA = () => { if (!selectedForScreen[1] || !selectedForScreen[2]) { showMessage({ type: MESSAGE_TYPE.BAD, text: "Selecciona 2 imágenes." }); return; } const item1 = ia.items.find(x => x.id === selectedForScreen[1]); const item2 = ia.items.find(x => x.id === selectedForScreen[2]); if (item1?.isHidden || item2?.isHidden) { showMessage({ type: MESSAGE_TYPE.BAD, text: "Imagen oculta." }); return; } const newSet = { id: `SET-${Date.now()}`, img1_id: selectedForScreen[1], img2_id: selectedForScreen[2], anim1: animationByScreen[1], anim2: animationByScreen[2], img1_thumb: item1?.thumbUrl, img2_thumb: item2?.thumbUrl }; player.addToQueue('IA', newSet); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Set agregado." }); setSelectedForScreen({ 1: null, 2: null }); setAnimationByScreen({ 1: 0, 2: 0 }); };
//   const ShowConfirmModalLegacy = (data, type) => { setSelfie(data); setModalType(type); setShowConfirmModal(true); };
//   const handleDirectDownload = async (item, index) => { try { if (!item?.contentUrl) return; const response = await fetch(`${process.env.REACT_APP_API_URL}SelfieFan/${item.id}/content`); if (!response.ok) { showMessage({ type: MESSAGE_TYPE.BAD, text: "Error." }); return; } const blob = await response.blob(); const ext = item.contentType?.includes("png") ? "png" : "jpg"; let sourceText = item.source === 'selfie_ia' ? '_IA' : ''; const formattedDateTime = BLFormatDateTimeToDownloadImages(item.createdAtUtc) || 'date'; const filename = `${index}${sourceText}_${formattedDateTime}.${ext}`; const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url); } catch { showMessage({ type: MESSAGE_TYPE.BAD, text: "Error." }); } };
//   const SelectSelfie = async () => { if (!selfie) return; if (selfie.isHidden) return; setSelectedForScreen({ 1: null, 2: null }); setAnimationByScreen({ 1: 0, 2: 0 }); const resp = await playerActions.sendToScreenFC(selfie); if(resp.success) { showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Mostrando." }); handleItemShown(selfie.id); } setShowConfirmModal(false); };
//   const DeselectSelfie = async () => { const resp = await BLDeselectSelfie(); if(resp.success) { showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Quitado." }); setFan(prev => ({...prev, items: prev.items.map(x => ({...x, isSelected: false}))})); } setShowConfirmModal(false); };
//   const DeleteSelfie = async () => { if (!selfie) return; const s = selfie; if (s.source === "selfie_ia") { setIA(prev => ({ ...prev, items: prev.items.filter(x => x.id !== s.id) })); } else { setFan(prev => ({ ...prev, items: prev.items.filter(x => x.id !== s.id) })); } const resp = await BLDeleteSelfie(s); if(resp.success) showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Eliminado." }); setShowConfirmModal(false); };
//   const ResetDinamyc = async () => { await BLResetCurrentDynamic(); setFan({ ...initialPagedState }); setIA({ ...initialPagedState }); player.clearQueue('FC'); player.clearQueue('IA'); await reloadNow(); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Reseteado." }); setShowConfirmModal(false); };
//   const toggleCardForScreen = (screenNum, cardId) => { setSelectedForScreen(prev => { const other = screenNum === 1 ? 2 : 1; if (prev[screenNum] === cardId) { setAnimationByScreen(a => ({ ...a, [screenNum]: 0 })); return { ...prev, [screenNum]: null }; } if (prev[other] === cardId) { setAnimationByScreen(a => ({ ...a, [other]: 0 })); return { ...prev, [other]: null, [screenNum]: cardId }; } return { ...prev, [screenNum]: cardId }; }); };
//   const setAnimationForScreen = (screenNum, animId) => { setAnimationByScreen(prev => ({ ...prev, [screenNum]: animId })); };
//   const SendSelfiesFanIAToScreen = async (screens) => { const id1 = selectedForScreen[1]; const id2 = selectedForScreen[2]; const item1 = ia.items.find(x => x.id === id1); const item2 = ia.items.find(x => x.id === id2); if ((screens.includes(1) && item1?.isHidden) || (screens.includes(2) && item2?.isHidden)) { showMessage({ type: MESSAGE_TYPE.BAD, text: "Imagen oculta." }); return; } const dataToSend = []; if (screens.includes(1) && id1) dataToSend.push({ id: id1, animation: animationByScreen[1] || 0 }); if (screens.includes(2) && id2) dataToSend.push({ id: id2, animation: animationByScreen[2] || 0 }); if(!dataToSend.length) return; const resp = await playerActions.sendToScreenIA(dataToSend); if(resp.success) { showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Enviado." }); setActiveShowAction(screens.length === 1 ? "screen1" : "screen2"); const idsMostrados = [id1, id2].filter(x => x); idsMostrados.forEach(id => handleItemShown(id)); } setShowConfirmModal(false); };
//   const ClearSelfiesFanIAFromScreen = async () => { await BLDeselectSelfieFanIA(); showMessage({ type: MESSAGE_TYPE.SUCCESS, text: "Pantalla limpia." }); setShowConfirmModal(false); };


//   // ----------------------------------------------------------------------------
//   // 6. RENDERIZADO (JSX)
//   // ----------------------------------------------------------------------------

//   if (isLoading) return <Loading />;

//   const currentQItem = player.queues[player.activeTab][player.currentIndex[player.activeTab]];
//   const isPauseIcon = player.playingTab === player.activeTab;

//   return (
//     <div className="SelfieFan">
//       <SecondaryBase actionToExecute={ReturnToDashboard}>

//         <div className="d-flex justify-content-center align-items-center mt-4 gap-3">
//             <button type="button" className="Btn__Adsl--RedOutlineTransparent mb-0" onClick={reloadNow}><i className="bi bi-arrow-counterclockwise"></i> Actualizar listado</button>
//             <button type="button" className="Btn__Adsl--RedOutlineTransparent" onClick={apiDownloadAll} title="Descargar todas las fotos en ZIP"><i className="bi bi-file-earmark-zip"></i> Descargar Todo</button>
//         </div>

//         {/* ===================== SECCIÓN 1: REPRODUCTOR ===================== */}
//         <div className='SelfieFan__Admin__Section'>
//           <p className="SelfieFan__Admin__Title"><i className='bi bi-play-circle'></i> Reproductor de Selfie Fan</p>
//           <button type="button" className="Btn__Adsl--RedOutlineTransparent d-block mx-auto mt-2" onClick={handleShowQROverlay}>
//             <i className="bi bi-qr-code"></i> Proyectar QR Selfiefan en overlay
//           </button>

//           <div className='SelfieFan__Admin__Player'>
//             {/* --- DECK --- */}
//             {player.activeTab === 'FC' ? (
//                 <div className='SelfieFan__Admin__Player__Deck'>
//                    <button type='button' className='Btn__Adsl--RedOutlineTransparent mx-auto mt-1' onClick={handleClearScreenRequest}><i className='bi bi-x-circle'></i> Quitar de la pantalla</button>
//                    <p className='SelfieFan__Admin__Player__Deck__LiveStatus'>Estatus: <i className={`bi bi-toggle-${player.isLive ? 'on text-success' : 'off'}`} onClick={handleLiveToggleRequest} title={player.isLive ? "En vivo" : "Detenido"}></i> {player.isLive ? "En vivo" : ""}</p>
//                    <p className="SelfieFan__Admin__Player__Deck__Feedback">{player.projectionStatus}</p>
                   
//                    <div className="SelfieFan__Admin__Player__Deck--FanCam__PreviewImage">
//                      {currentQItem ? (<img src={currentQItem.thumbUrl} className='d-block w-100 h-100' style={{objectFit:'contain'}} alt='' key={currentQItem.thumbUrl} />) : <div className="text-white d-flex align-items-center justify-content-center h-100">No hay fotos en la fila</div>}
//                    </div>
                   
//                    <div className='SelfieFan__Admin__Player__Deck--FanCam__Intervals'>
//                      <p className='mb-0 me-1'>Intervalo:</p>
//                      {[1000, 2000, 3000, 4000, 5000, 8000, 10000].map(ms => (<label key={ms} className='SelfieFan__Admin__Player__Deck--FanCam__Intervals__Items'><input type='radio' name="timeFC" checked={player.autoPlayIntervalFC === ms} onChange={() => player.setAutoPlayIntervalFC(ms)}/> {ms/1000}s</label>))}
//                    </div>
//                    <div className='SelfieFan__Admin__Player__Deck--FanCam__Controls'>
//                       <button type='button' className='SelfieFan__Admin__Player__Deck--FanCam__Controls__Buttons Btn__Adsl--RedOutlineTransparent' onClick={player.playPrev}><i className="bi bi-caret-left-fill"></i> Anterior</button>
//                       <button type='button' className={`SelfieFan__Admin__Player__Deck--FanCam__Controls__Buttons ${isPauseIcon ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={player.togglePlay}><i className={`bi bi-${isPauseIcon ? 'pause-fill' : 'play-circle'}`}></i> Proyectar</button>
//                       <button type='button' className='SelfieFan__Admin__Player__Deck--FanCam__Controls__Buttons Btn__Adsl--RedOutlineTransparent' onClick={() => player.playNext('FC')}>Siguiente <i className="bi bi-caret-right-fill"></i></button>
//                    </div>
//                 </div>
//             ) : (
//                 <div className='SelfieFan__Admin__Player__Deck'>
//                     <button type='button' className='Btn__Adsl--RedOutlineTransparent mx-auto mt-1' onClick={handleClearScreenRequest}><i className='bi bi-x-circle'></i> Quitar de la pantalla</button>
//                     <p className='SelfieFan__Admin__Player__Deck__LiveStatus'>Estatus: <i className={`bi bi-toggle-${player.isLive ? 'on text-success' : 'off'}`} onClick={handleLiveToggleRequest} title={player.isLive ? "En vivo" : "Detenido"}></i> {player.isLive ? "En vivo" : ""}</p>
//                     <p className="SelfieFan__Admin__Player__Deck__Feedback">{player.projectionStatus}</p>
//                     <div className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage'>
//                         <button type='button' className='Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage--Lg__ArrowButtons' onClick={player.playPrev}><i className="bi bi-caret-left-fill"></i></button>
//                         <div className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps'>
//                             <p className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__Title'>Pantalla #1</p>
//                             <div className={`SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer ${player.iaSequenceStep === 1 ? 'SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer--Active' : ''}`}>
//                                 {currentQItem && <img src={currentQItem.img1_thumb} className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer__Image' alt='1' key={currentQItem.img1_thumb} />}
//                             </div>
//                             {currentQItem && (<div className='d-flex justify-content-center mt-1'>{[0,1,2,3].map(a => (<button key={`p1-a${a}`} type="button" className={`mx-auto mb-0 ${currentQItem.anim1 === a ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={() => player.updateCurrentItemAnimation(1, a)} style={{fontSize:'0.7rem'}}>{a}</button>))}</div>)}
//                             <button type='button' className={`mt-2 mx-auto ${player.iaSequenceStep === 1 && player.isLive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={() => player.triggerIaStep(1)}>Proyectar la #1</button>
//                         </div>
//                         <div className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps ms-3'>
//                             <p className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__Title'>Pantalla #2</p>
//                             <div className={`SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer ${player.iaSequenceStep === 2 ? 'SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer--Active' : ''}`}>
//                                 {currentQItem ? (<img src={currentQItem.img2_thumb} className='SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage__Steps__ImageContainer__Image' alt='2' key={currentQItem.img2_thumb} />) : <span className="text-muted">Set</span>}
//                             </div>
//                             {currentQItem && (<div className='d-flex justify-content-center mt-1'>{[0,1,2,3].map(a => (<button key={`p2-a${a}`} type="button" className={`mx-auto mb-0 ${currentQItem.anim2 === a ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={() => player.updateCurrentItemAnimation(2, a)} style={{fontSize:'0.7rem'}}>{a}</button>))}</div>)}
//                             <button type='button' className={`mt-2 mx-auto ${player.iaSequenceStep === 2 && player.isLive ? 'Btn__Adsl--Red' : 'Btn__Adsl--RedOutlineTransparent'}`} onClick={() => player.triggerIaStep(2)}>Proyectar la #2</button>
//                         </div>
//                         <button type='button' className='Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__Player__Deck--FanCamIA__PreviewImage--Lg__ArrowButtons' onClick={() => player.playNext('IA')}><i className="bi bi-caret-right-fill"></i></button>
//                     </div>
//                 </div>
//             )}

//             {/* --- LISTA DE REPRODUCCIÓN --- */}
//             <div className='SelfieFan__Admin__Player__Playlist'>
//               <div className='SelfieFan__Admin__Player__Playlist__Tabs'>
//                 <button type='button' className={`${player.activeTab === 'FC' ? 'Btn__Adsl--Red bi bi-check-circle-fill' : 'Btn__Adsl--RedOutlineTransparent'} SelfieFan__Admin__Player__Playlist__Tabs__Buttons`} onClick={() => player.setActiveTab('FC')}> Fan Cam</button>
//                 <button type='button' className={`${player.activeTab === 'IA' ? 'Btn__Adsl--Red bi bi-check-circle-fill' : 'Btn__Adsl--RedOutlineTransparent'} SelfieFan__Admin__Player__Playlist__Tabs__Buttons`} onClick={() => player.setActiveTab('IA')}> IA</button>
//               </div>
//               <div className='SelfieFan__Admin__Player__Playlist__Photos'>
//                 <div className='SelfieFan__Admin__Player__Playlist__Photos__List'>
//                     {player.queues[player.activeTab].map((item, idx) => {
//                         const isCurrent = idx === player.currentIndex[player.activeTab];
//                         const showArrows = player.queues[player.activeTab].length > 1;
//                         return (
//                           <div key={item._queueId || idx} className={`SelfieFan__Admin__Player__Playlist__Photos__List__Items ${isCurrent ? 'Btn__Adsl--RedOutline' : 'Btn__Adsl--RedOutlineTransparent'} ${item.isHidden ? 'opacity-50' : ''}`} onClick={() => player.jumpToItem(player.activeTab, idx)}>
//                             <div className='d-flex align-items-center flex-grow-1'>
//                                 <div className='d-flex flex-column me-2 justify-content-center'>
//                                     <button type='button' className='btn btn-sm border-0' onClick={(e) => { e.stopPropagation(); handleDeleteFromQueueRequest(idx); }}><i className='bi bi-trash'></i></button>
//                                 </div>
//                                 <img src={player.activeTab === 'FC' ? item.thumbUrl : item.img1_thumb} style={{ width: '50px', height: '50px', objectFit:'cover' }} alt="" className="rounded me-2" key={item.thumbUrl} />
//                                 <small className="text-truncate" style={{maxWidth: '100px'}}>{player.activeTab === 'FC' ? `Foto #${item.index || '?'}` : `Set #${idx+1}`}</small>
//                             </div>
//                             {showArrows && (
//                                 <div className='d-flex flex-column ms-2'>
//                                     <button type='button' className='btn btn-sm p-0' onClick={(e) => { e.stopPropagation(); player.reorderQueue(player.activeTab, idx, idx-1); }}><i className='bi bi-arrow-up'></i></button>
//                                     <button type='button' className='btn btn-sm p-0' onClick={(e) => { e.stopPropagation(); player.reorderQueue(player.activeTab, idx, idx+1); }}><i className='bi bi-arrow-down'></i></button>
//                                 </div>
//                             )}
//                           </div>
//                         )
//                     })}
//                 </div>
//               </div>
//               {player.queues[player.activeTab].length > 0 && (<button type="button" className="Btn__Adsl--RedOutlineTransparent mt-4" title={`Vaciar fila de ${player.activeTab}`} onClick={() => { setModalType(types.CLEAR_QUEUE); setShowConfirmModal(true); }}><i className="bi bi-trash3-fill"></i> Borrar lista de reproducción</button>)}
//             </div>
//           </div>
//         </div>

//         {/* ===================== SECCIÓN 2: BIBLIOTECA FAN CAM ===================== */}
//         <div className="SelfieFan__Admin__Section">
//           <div className="d-flex justify-content-between align-items-center mb-2 px-3">
//              <div className="d-flex align-items-center">
//                  <img src="/img/selfiefan/Adsl-FanCam.png" className="SelfieFan__Admin__Section__Logo me-3" alt="" />
//                  <p className="SelfieFan__Admin__Title mb-0">Selfie Fan</p>
//              </div>
//              <div className="d-flex align-items-center">
//                  <span className="me-2 text-white small">Ordenar:</span>
//                  <div className="btn-group btn-group-sm">
//                      <button type="button" className={`btn ${sortConfig.FC === 'ASC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('FC', 'ASC')}>Ascendente</button>
//                      <button type="button" className={`btn ${sortConfig.FC === 'DESC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('FC', 'DESC')}>Descendente</button>
//                  </div>
//              </div>
//           </div>

//           <p className="text-center">Total de fotos: {fan.items.length}</p>
//           <button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => setIsFanCollapsed(c => !c)}>{isFanCollapsed ? "Mostrar" : "Ocultar"} <i className={`bi ${isFanCollapsed ? "bi-caret-down-fill" : "bi-caret-up-fill"}`}></i></button>
//           <div ref={fanCollapsibleRef} className="Collapsible">
//             <div ref={fanContainerRef}>
//               {fan.items.length > 0 && (
//                 <p className="SelfieFan__Admin__Text--Center">Selecciona la foto que deseas mostrar en pantalla:</p>
//               )}
//               <div className="flex gap-2 justify-center mt-3 mb-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_fan")} disabled={fan.loading}>{fan.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
//               {fan.items.length === 0 ? (<p className="SelfieFan__Admin__Text--Center">Actualmente no hay fotos</p>) : (
//                 <>
//                   <div className="SelfieFan__Admin__List">
//                     {getSortedItems(fan.items, 'FC').map((it, index) => (
//                       <div key={it.id} className={`SelfieFan__Admin__List__Item ${it.isSelected ? "SelfieFan__Admin__List__Item--Active" : ""} ${it.isHidden ? "opacity-50" : ""}`} style={it.wasShown ? {position: 'relative'} : {}}>
//                         {it.wasShown && <span style={{position:'absolute', top:'5px', right:'5px', background:'#0d6efd', color:'white', borderRadius:'50%', padding:'2px', fontSize:'12px', width:'20px', height:'20px', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10}} title="Ya mostrada"><i className="bi bi-check-lg"></i></span>}
//                         <div className="SelfieFan__Admin__List__Item__Buttons">
//                           <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => handleAddToQueueFC(it)} title="Agregar a la fila" disabled={it.isHidden}><i className="bi bi-music-note-list"></i></button>
//                           <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => apiRotate(it.id)} title="Rotar" disabled={it.isHidden}><i className="bi bi-arrow-clockwise"></i></button>
//                           <button type="button" className={`Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button ${it.isHidden ? 'text-warning' : ''}`} onClick={() => apiToggleHide(it.id)} title={it.isHidden ? "Mostrar" : "Ocultar"}><i className={`bi ${it.isHidden ? 'bi-eye-slash-fill' : 'bi-eye'}`}></i></button>
//                           {it.contentUrl && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => handleDirectDownload(it, it.index || index + 1)} title="Descargar"><i className="bi bi-download"></i></button>)}
//                           {!it.isSelected && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => ShowConfirmModalLegacy(it, types.DELETE)} title="Eliminar" disabled={it.isHidden}><i className="bi bi-trash"></i></button>)}
//                         </div>
//                         <p>#{it.index || '?'}</p>
//                         <img src={it.thumbUrl} className="SelfieFan__Admin__Image--Normal" alt={it.caption} loading="lazy" key={it.thumbUrl} />
//                         <p>Fecha: {FormatDateToMexico(it.createdAtUtc)}</p>
//                         {it.isSelected ? (<button type="button" className="Btn__Adsl--Success" onClick={() => ShowConfirmModalLegacy(it, types.DESELECT)}><i className="bi bi-x-circle"></i> Quitar de la pantalla</button>) : (<button type="button" className="Btn__Adsl--RedOutlineTransparent" onClick={() => ShowConfirmModalLegacy(it, types.SELECT)} disabled={it.isHidden}><i className="bi bi-tv"></i> Mostrar en pantalla ahora</button>)}
//                       </div>
//                     ))}
//                   </div>
//                 </>
//               )}
//               <div className="flex gap-2 justify-center mt-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_fan")} disabled={fan.loading}>{fan.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
//             </div>
//           </div>
//         </div>

//         {/* ===================== SECCIÓN 3: BIBLIOTECA FAN CAM IA ===================== */}
//         <div className="SelfieFan__Admin__Section">
//           <div className="d-flex justify-content-between align-items-center mb-2 px-3">
//              <div className="d-flex align-items-center">
//                  <img src="/img/selfiefan/IADSL.png" className="SelfieFan__Admin__Section__Logo me-3" alt="" />
//                  <p className="SelfieFan__Admin__Title mb-0">Selfie Fan con IA</p>
//              </div>
//              <div className="d-flex align-items-center">
//                  <span className="me-2 text-white small">Ordenar:</span>
//                  <div className="btn-group btn-group-sm">
//                      <button type="button" className={`btn ${sortConfig.IA === 'ASC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('IA', 'ASC')}>Ascendente</button>
//                      <button type="button" className={`btn ${sortConfig.IA === 'DESC' ? 'btn-danger' : 'btn-outline-secondary text-white'}`} onClick={() => setOrderFor('IA', 'DESC')}>Descendente</button>
//                  </div>
//              </div>
//           </div>

//           <p className="text-center">Total de fotos: {ia.items.length}</p>
//           <button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => setIsIACollapsed(c => !c)}>{isIACollapsed ? "Mostrar" : "Ocultar"} <i className={`bi ${isIACollapsed ? "bi-caret-down-fill" : "bi-caret-up-fill"}`}></i></button>
//           <div ref={iaCollapsibleRef} className="Collapsible">
//             <div ref={iaContainerRef}>
//               <div className="flex gap-2 justify-center mt-3 mb-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_ia")} disabled={ia.loading}>{ia.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
//               {ia.items.length === 0 ? (<p className="SelfieFan__Admin__Text--Center">Actualmente no hay fotos con IA</p>) : (
//                 <>
//                   <div className="SelfieFanIA__Admin__FakeScreen">
//                     <div className="SelfieFanIA__Admin__FakeScreen__Squares">
//                       <div className="SelfieFanIA__Admin__FakeScreen__Squares__Screens">
//                         <p>Pantalla #1</p>
//                         <img src={(() => { const id = selectedForScreen[1]; const found = ia.items.find(x => x.id === id); return found ? found.thumbUrl : "/img/page/Fondo-Azul-Five-Screen.png"; })()} className="SelfieFanIA__Admin__FakeScreen__Squares__Screens__Image" alt="P1" key={selectedForScreen[1] ? ia.items.find(x => x.id === selectedForScreen[1])?.thumbUrl : 'def1'} />
//                         <div className="SelfieFanIA__Admin__FakeScreen__Squares__Screens__EffectButtons">{[0,1,2,3].map(anim => (<button key={`anim1-${anim}`} type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__Squares__Screens__EffectButtons__Buttons", animationByScreen[1] === anim)} onClick={() => setAnimationForScreen(1, anim)} disabled={!selectedForScreen[1]}>{anim === 0 ? "Ninguno" : anim}</button>))}</div>
//                       </div>
//                       <div className="SelfieFanIA__Admin__FakeScreen__Squares__Screens">
//                         <p>Pantalla #2</p>
//                          <img src={(() => { const id = selectedForScreen[2]; const found = ia.items.find(x => x.id === id); return found ? found.thumbUrl : "/img/page/Fondo-Azul-Five-Screen.png"; })()} className="SelfieFanIA__Admin__FakeScreen__Squares__Screens__Image" alt="P2" key={selectedForScreen[2] ? ia.items.find(x => x.id === selectedForScreen[2])?.thumbUrl : 'def2'} />
//                         <div className="SelfieFanIA__Admin__FakeScreen__Squares__Screens__EffectButtons">{[0,1,2,3].map(anim => (<button key={`anim2-${anim}`} type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__Squares__Screens__EffectButtons__Buttons", animationByScreen[2] === anim)} onClick={() => setAnimationForScreen(2, anim)} disabled={!selectedForScreen[2]}>{anim === 0 ? "Ninguno" : anim}</button>))}</div>
//                       </div>
//                     </div>
//                     <div className="SelfieFanIA__Admin__FakeScreen__ActionButtons">
//                       <button type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__ActionButtons__Buttons", activeShowAction === "screen1")} disabled={!selectedForScreen[1]} onClick={() => ShowConfirmModalLegacy(null, types.IA_SHOW1)}>Proyectar pantalla #1</button>
//                       <button type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__ActionButtons__Buttons", activeShowAction === "screen2")} disabled={!selectedForScreen[1] || !selectedForScreen[2]} onClick={() => ShowConfirmModalLegacy(null, types.IA_SHOW_BOTH)}>Proyectar pantalla #2</button>
//                       <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__ActionButtons__Buttons" onClick={() => ShowConfirmModalLegacy(null, types.IA_CLEAR)} disabled={isClearingIA}>Quitar de la pantalla</button>
//                       <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFanIA__Admin__FakeScreen__ActionButtons__Buttons" onClick={handleAddSetToQueueIA} disabled={!selectedForScreen[1] || !selectedForScreen[2]} style={{ marginTop: '10px' }}><i className="bi bi-music-note-list"></i> Agregar set a la fila</button>
//                     </div>
//                   </div>

//                   <div className="SelfieFanIA__Admin__List">
//                     {getSortedItems(ia.items, 'IA').map((it, index) => {
//                       const isFor1 = selectedForScreen[1] === it.id; const isFor2 = selectedForScreen[2] === it.id; const selectedForAny = isFor1 || isFor2;
//                       return (
//                         <div key={it.id} className={`SelfieFan__Admin__List__Item ${it.isSelected ? "SelfieFan__Admin__List__Item--Active" : ""} ${it.isHidden ? "opacity-50" : ""}`} style={it.wasShown ? {position: 'relative'} : {}}>
//                           {it.wasShown && <span style={{position:'absolute', top:'5px', right:'5px', background:'#0d6efd', color:'white', borderRadius:'50%', padding:'2px', fontSize:'12px', width:'20px', height:'20px', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10}} title="Ya mostrada"><i className="bi bi-check-lg"></i></span>}
//                           <div className="SelfieFan__Admin__List__Item__Buttons">
//                             {it.contentUrl && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => handleDirectDownload(it, it.index || index + 1)}><i className="bi bi-download"></i></button>)}
//                             <button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => apiRotate(it.id)} title="Rotar" disabled={it.isHidden}><i className="bi bi-arrow-clockwise"></i></button>
//                             <button type="button" className={`Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button ${it.isHidden ? 'text-warning' : ''}`} onClick={() => apiToggleHide(it.id)} title={it.isHidden ? "Mostrar" : "Ocultar"}><i className={`bi ${it.isHidden ? 'bi-eye-slash-fill' : 'bi-eye'}`}></i></button>
//                             {(!it.isSelected && !selectedForAny) && (<button type="button" className="Btn__Adsl--RedOutlineTransparent SelfieFan__Admin__List__Item__Buttons__Button" onClick={() => ShowConfirmModalLegacy({ ...it, source: "selfie_ia" }, types.DELETE)} disabled={it.isHidden}><i className="bi bi-trash"></i></button>)}
//                           </div>
//                           <p>#{it.index || '?'}</p>
//                           <img src={it.thumbUrl} className="SelfieFan__Admin__Image--Normal" alt="img" key={it.thumbUrl} />
//                           <div className="SelfieFan__Admin__List__Item__Buttons">
//                              <button type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent mx-auto", isFor1)} disabled={selectedForScreen[2] === it.id || it.isHidden} onClick={() => toggleCardForScreen(1, it.id)}><i className="bi bi-plus-circle"></i> Agregar a Pantalla #1</button>
//                              <button type="button" className={btnClass("Btn__Adsl--RedOutlineTransparent mx-auto", isFor2)} disabled={selectedForScreen[1] === it.id || it.isHidden} onClick={() => toggleCardForScreen(2, it.id)}><i className="bi bi-plus-circle"></i> Agregar a Pantalla #2</button>
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </>
//               )}
//               <div className="flex gap-2 justify-center mt-3"><button type="button" className="Btn__Adsl--RedOutlineTransparent mx-auto" onClick={() => loadMore("selfie_ia")} disabled={ia.loading}>{ia.loading ? "Cargando..." : <><i className="bi bi-arrow-counterclockwise"></i> Cargar más</>}</button></div>
//             </div>
//           </div>
//         </div>

//         {/* ===================== SECCIÓN EXCLUSIVA: OVERLAY Y TRACKPAD ===================== */}
//         <div className="SelfieFan__Admin__Section">
//           <p className="SelfieFan__Admin__Title">Overlay Selfie Fan</p>
//           <button type="button" className="Btn__Adsl--RedOutlineTransparent d-block mx-auto mt-2" onClick={handleShowQROverlay}>
//             <i className="bi bi-qr-code"></i> Proyectar QR Selfiefan en overlay
//           </button>
          
//           {/* <p className="text-center mb-0 mt-4">Establece la posición de la imagen en el overlay</p> */}

//           <div className="card shadow-sm mb-4 border-danger mt-4" style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'transparent' }}>
//             <div className="card-header bg-danger text-white font-weight-bold d-flex justify-content-between align-items-center">
//                 <span><i className="bi bi-display me-2"></i> Configuración de Overlay - Establece la posición de la imagen en el overlay</span>
                
//                 <div className="d-flex align-items-center gap-2">
//                     {/* <button type="button" className="btn btn-sm btn-dark text-white fw-bold me-2 border-secondary" onClick={handleShowQROverlay}>
//                         <i className="bi bi-qr-code"></i> Proyectar QR
//                     </button>
//                     <button type="button" className="btn btn-sm btn-light text-dark fw-bold" onClick={handleApplyOverlayToScreen} disabled={isOverlaySyncing}>
//                         <i className="bi bi-tv"></i> Aplicar en Pantalla
//                     </button>
//                     <button type="button" className={`btn btn-sm fw-bold ${hasUnsavedChanges ? 'btn-warning text-dark' : 'btn-success text-white'}`} onClick={handleSaveOverlayConfig}>
//                         <i className="bi bi-save"></i> Guardar
//                     </button> */}
//                 </div>
//             </div>
            
//             <div className="card-body">
                
//                 {hasUnsavedChanges && (
//                     <div className="alert alert-warning py-2 mb-4 text-center small">
//                         <i className="bi bi-exclamation-triangle-fill me-2"></i>
//                         Tienes cambios sin guardar. Presiona <strong>"Guardar"</strong> para mantenerlos la próxima vez.
//                     </div>
//                 )}
//                 {/* {!hasUnsavedChanges && lastSavedDate && (
//                     <div className="text-center mb-3">
//                         <small className="text-success"><i className="bi bi-check2-circle"></i> Último guardado: {FormatDateToMexico(lastSavedDate)}</small>
//                     </div>
//                 )} */}

//                 <div className="d-flex justify-content-between align-items-center mb-1">
//                     <p className="font-weight-bold mb-0 text-center"><i className="bi bi-arrows-move me-1"></i> Trackpad Virtual de Posición</p>
//                     <span className={`badge ${isOverlaySyncing ? 'bg-warning text-dark' : 'bg-transparent text-muted'}`}>
//                         {isOverlaySyncing ? 'Enviando a pantalla...' : ''}
//                     </span>
//                 </div>
                
//                 <p className="small text-muted mb-3">Arrastra el recuadro rojo con tu dedo o mouse para mover la imagen dinámicamente.</p>
                
//                 <div className="d-flex justify-content-center">
//                     <div 
//                         style={{
//                             width: '100%', maxWidth: '400px', height: '225px', backgroundColor: '#1a1a1a', 
//                             position: 'relative', overflow: 'hidden', borderRadius: '12px', border: '2px solid #444',
//                             boxShadow: 'inset 0 0 20px rgba(0,0,0,0.8)', touchAction: 'none', 
//                             cursor: isDraggingTrackpad ? 'grabbing' : 'grab'
//                         }}
//                         onPointerDown={handleTrackpadPointerDown} onPointerMove={handleTrackpadPointerMove}
//                         onPointerUp={handleTrackpadPointerUp} onPointerCancel={handleTrackpadPointerUp} onPointerLeave={handleTrackpadPointerUp}
//                     >
//                         <div style={{
//                             position: 'absolute', right: `${(overlayX / 1700) * 85}%`, bottom: `${(overlayY / 700) * 80}%`,
//                             width: '15%', height: '20%', backgroundColor: isDraggingTrackpad ? 'rgba(255, 0, 0, 0.9)' : 'rgba(255, 0, 0, 0.5)',
//                             border: '2px solid #ff4d4d', borderRadius: '4px', transform: `scale(${overlayScale})`,
//                             transformOrigin: 'bottom right', pointerEvents: 'none', display: 'flex',
//                             justifyContent: 'center', alignItems: 'center', transition: isDraggingTrackpad ? 'none' : 'all 0.1s ease-out'
//                         }}>
//                             <i className="bi bi-camera text-white" style={{ fontSize: '1.2rem' }}></i>
//                         </div>
//                         <div style={{ position: 'absolute', top: '50%', left: 0, right: 0, borderTop: '1px dashed #333', pointerEvents: 'none' }}></div>
//                         <div style={{ position: 'absolute', left: '50%', top: 0, bottom: 0, borderLeft: '1px dashed #333', pointerEvents: 'none' }}></div>
//                     </div>
//                 </div>

//                 <button type="button" className={`mx-auto d-block mt-4 Btn__Adsl--RedOutlineTransparent mb-0`} onClick={handleSaveOverlayConfig}>
//                   <i className="bi bi-save"></i> Guardar configuraciones
//                 </button>
//                 {!hasUnsavedChanges && lastSavedDate && (
//                   <div className="text-center mb-3">
//                     <small className="text-success">Último guardado: {FormatDateToMexico(lastSavedDate)}</small>
//                   </div>
//                 )}

//                 <hr className="my-4 border-secondary" />
                
//                 <p className='text-center'>¿No se visualizan en pantalla las configuraciones que estableciste?</p>
//                 <button type="button" className="Btn__Adsl--RedOutlineTransparent d-block mx-auto" onClick={handleApplyOverlayToScreen} disabled={isOverlaySyncing}>
//                   <i className="bi bi-tv"></i> Aplicar configuraciones ahora
//                 </button>

//                 <hr className="my-4 border-secondary" />

//                 <p className="small text-muted mb-3">Establece los valores que deseas para la imagen del overlay.</p>

//                 <div className="row mb-4">
//                     <div className="col-md-6">
//                         <div className="mb-3">
//                             <label className="form-label font-weight-bold d-flex justify-content-between">
//                                 <span>Mover Horizontal (X):</span>
//                                 {/* <span className="text-info">{overlayX} px</span> */}
//                             </label>
//                             <div className="d-flex align-items-center">
//                                 <input type="range" className="form-range flex-grow-1 me-3" min="0" max="1700" step="10" value={overlayX} onChange={(e) => setOverlayX(parseInt(e.target.value))} />
//                                 <input type="number" className="form-control form-control-sm text-center bg-dark text-white border-secondary p-0" style={{ width: '120px' }} value={overlayX} onChange={(e) => setOverlayX(parseInt(e.target.value) || 0)} /><span className='ms-1'>px</span>
//                             </div>
//                         </div>

//                         <div className="mb-3">
//                             <label className="form-label font-weight-bold d-flex justify-content-between">
//                                 <span>Mover Vertical (Y):</span>
//                                 {/* <span className="text-info">{overlayY} px</span> */}
//                             </label>
//                             <div className="d-flex align-items-center">
//                                 <input type="range" className="form-range flex-grow-1 me-3" min="0" max="700" step="10" value={overlayY} onChange={(e) => setOverlayY(parseInt(e.target.value))} />
//                                 <input type="number" className="form-control form-control-sm text-center bg-dark text-white border-secondary p-0" style={{ width: '120px' }} value={overlayY} onChange={(e) => setOverlayY(parseInt(e.target.value) || 0)} /><span className='ms-1'>px</span>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="col-md-6 border-start border-secondary d-flex flex-column justify-content-center">
//                         <label className="form-label font-weight-bold d-flex justify-content-between">
//                             <span>Tamaño (Escala):</span>
//                             {/* <span className="text-info">{overlayScale}x</span> */}
//                         </label>
//                         <div className="d-flex align-items-center mb-2">
//                             <input type="range" className="form-range flex-grow-1 me-3" min="0.3" max="2.5" step="0.1" value={overlayScale} onChange={(e) => setOverlayScale(parseFloat(e.target.value))} />
//                             <input type="number" className="form-control form-control-sm text-center bg-dark text-white border-secondary p-0" style={{ width: '120px' }} step="0.1" value={overlayScale} onChange={(e) => setOverlayScale(parseFloat(e.target.value) || 1)} />
//                         </div>
//                         <small className="text-muted text-center"><i className="bi bi-info-circle"></i> 1.0 = Tamaño Original (Max 250px)</small>
//                     </div>
//                 </div>

//                 <button type="button" className={`mx-auto d-block mt-4 Btn__Adsl--RedOutlineTransparent mb-0`} onClick={handleSaveOverlayConfig}>
//                   <i className="bi bi-save"></i> Guardar configuraciones
//                 </button>
//                 {!hasUnsavedChanges && lastSavedDate && (
//                   <div className="text-center mb-3">
//                     <small className="text-success">Último guardado: {FormatDateToMexico(lastSavedDate)}</small>
//                   </div>
//                 )}

//             </div>
//           </div>
//         </div>

//         {/* ... Modales ... */}
//         {showConfirmModal && (
//           <>
//              {modalType === types.CONFIRM_START_LIVE && (<Confirm message="¿Deseas iniciar la proyección a la pantalla grande?" actionToYesButton={confirmLiveAction} textYesButton="Sí, iniciar" textNoButton="Cancelar" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.CONFIRM_STOP_LIVE && (<Confirm message="¿Deseas detener la proyección?" actionToYesButton={confirmLiveAction} textYesButton="Sí, detener" textNoButton="Cancelar" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.PLAYER_CLEAR && (<Confirm message="¿Estás seguro de detener la proyección y limpiar la pantalla grande?" actionToYesButton={confirmClearScreen} textYesButton="Sí, limpiar" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.DELETE_FROM_QUEUE && (<Confirm message="¿Deseas quitar esta foto de la fila de reproducción?" actionToYesButton={confirmDeleteFromQueue} textYesButton="Sí, quitar" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.CLEAR_QUEUE && (<Confirm message={`¿Estás seguro de eliminar toda la fila de reproducción ${player.activeTab && player.activeTab === 'FC' ? 'de Fan Cam' : 'Fan Cam con IA'}? (Esta acción no se puede deshacer)`} actionToYesButton={confirmClearQueue} textYesButton="Sí, eliminar todo" textNoButton="Cancelar" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
             
//              {modalType === types.SELECT && (<Confirm message={`¿Estás segur@ de proyectar en la pantalla la Selfie Fan (${selfie?.index || selfie?.id})?`} image={selfie?.thumbUrl} actionToYesButton={SelectSelfie} textYesButton="Sí, proyectar ahora" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.DESELECT && (<Confirm message={`¿Estás segur@ de quitar de la pantalla la Selfie Fan (${selfie?.index || selfie?.id})?`} image={selfie?.thumbUrl} actionToYesButton={DeselectSelfie} textYesButton="Sí, quitar ahora" textNoButton={"No"} setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.DELETE && (<Confirm message={`¿Estás segur@ de eliminar la Selfie (${selfie?.index || selfie?.id})?`} image={selfie?.thumbUrl} actionToYesButton={DeleteSelfie} textYesButton="Sí, eliminar" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.RESET && (<Confirm message="¿Estás segur@ de reiniciar la dinámica completa?" image={null} actionToYesButton={ResetDinamyc} textYesButton="Sí, reiniciar ahora" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.IA_SHOW1 && (<Confirm message="¿Deseas proyectar solo la Pantalla #1?" image={null} actionToYesButton={() => SendSelfiesFanIAToScreen([1])} textYesButton="Sí, proyectar 1" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.IA_SHOW_BOTH && (<Confirm message="¿Deseas proyectar la Pantalla #1 y #2?" image={null} actionToYesButton={() => SendSelfiesFanIAToScreen([1,2])} textYesButton="Sí, proyectar 1 y 2" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//              {modalType === types.IA_CLEAR && (<Confirm message="¿Deseas quitar las imágenes de la pantalla grande?" image={null} actionToYesButton={ClearSelfiesFanIAFromScreen} textYesButton="Sí, quitar ahora" textNoButton="No" setShowModal={setShowConfirmModal} setConfirmData={() => {}} />)}
//           </>
//         )}

//       </SecondaryBase>
//     </div>
//   );
// };

// export { SelfieFanPlayer };